import React, { Component } from 'react';
import Header from '../../layouts/Header';
import HeaderV1 from '../../layouts/HeaderV1';
import Footer from '../../layouts/Footer';
import { Hobbies_Banner } from '../../components/Home/Banner';
import FetchCall from '../../API/FetchCall';
import { getSchoolCategoryIdBySlug, getAllPresSchools, hobbiesSecondSubFilter, TrendingResults, catgoryList, saveEnqLead } from '../../API/FetchCall';
import { Link } from 'react-router-dom';
import { TopTrending } from '../Banner/topTrending';
import { LeadSmall } from '../Banner/LeadSmall';
import { ArticleSmall } from '../Banner/ArticleSmall';
import ReactTooltip from "react-tooltip";
import Rating from 'react-star-rating-component';
import {
  BASE_URL, RATING_GOOGLE, MAXDIS_FIL, FIL_DIS, SCREEN_SIZE,AZ_ASSET_PATH,
  MAXFEE_FILP, MAXDIS_FILP, FIL_FEEP, CENTERLAT, CENTERLNG,
  MAXFEE_FILPlay1, PAGI_PERPAGE, PAGINATION_LBL, DEFAULT_DIS, DEFAULT_FEE, DEFAULT_FEE_OTHER
} from '../../constant';
import { AdsOne, AdsTwo, AdsHorizandal, AdsVertical, AdsDynamicMobileMiddle } from '../../components/others/ads';
import { AfterSchoolRight } from '../../components/others/ads_vertical_landing';
import JwPagination from 'jw-react-pagination';
import $ from 'jquery';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import Geocode from "react-geocode";

import CardSkeleton from './CardSkeleton';
import { Modal, ModalBody } from 'reactstrap';

import closebtn from '../../../src/assets/icons/close.svg';

import { Helmet } from 'react-helmet';
import meta_function from '../../meta_data';
import { conditionallyUpdateScrollbar } from 'reactstrap/lib/utils';
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

import { TopTrendingUpdated } from '../Banner/topTrendingUpdated';

import filtericon from '../../../src/assets/icons/filter.png';

import { verticalTotalCount, verticalListing } from '../../API/FetchCall';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import actionicon1 from "./../../assets/icons/v2/compare.png";
import actionicon3 from "./../../assets/icons/v2/wishlist.png";
import { addToWishList, addToCompareList } from '../../common.js';

import AllVerticalSte1 from "../Leads/verticalStep1";

import compareicon from "./../../assets/icons/balance.png";
import stampedicon from "./../../assets/icons/stamps/stamp.png";

class AfterSchoolActivitiesCategories extends Component {
  constructor(props) {
    super(props);
    let meta = meta_function.get_meta_data('af-scl-act', this.props.match.params.subcategory2, this.props.match.params.city);

    if (!sessionStorage.getItem('type_texts')) {
      sessionStorage.setItem('type_texts', '');
      sessionStorage.setItem('type_ids', '');
    }

    if (!sessionStorage.getItem('learninglocation_texts')) {
      sessionStorage.setItem('learninglocation_texts', '');
      sessionStorage.setItem('learninglocation_ids', '');
    }

    if (!sessionStorage.getItem('affilation_texts')) {
      sessionStorage.setItem('affilation_texts', '');
      sessionStorage.setItem('affilation_ids', '');
    }

    if (!sessionStorage.getItem('curriculam_texts')) {
      sessionStorage.setItem('curriculam_texts', '');
      sessionStorage.setItem('curriculam_ids', '');
    }

    if (!sessionStorage.getItem('classification_texts')) {
      sessionStorage.setItem('classification_texts', '');
      sessionStorage.setItem('classification_ids', '');
    }

    if (!sessionStorage.getItem('location_texts'))
      sessionStorage.setItem('location_texts', '');

    if (!sessionStorage.getItem('fees_texts'))
      sessionStorage.setItem('fees_texts', '');

    if (!sessionStorage.getItem('ratings_texts'))
      sessionStorage.setItem('ratings_texts', '');

    if (!sessionStorage.getItem('googleratings_texts'))
      sessionStorage.setItem('googleratings_texts', '');

    this.state = {
      meta_title: meta.meta_title,
      meta_desc: meta.meta_desc,
      pageindex: 1,
      totalsplitpages: 0,
      totalrecords: 0,
      pgnumber: 0,
      cate_desc: '',
      similarList: [],
      pageOfItems: [],
      review: 0,
      reviews: 0,
      review_change: false,
      review_social: 0,
      showElements: false,
      distance_option: false,
      facilities_option: false,
      classification_option: false,
      learning_option: false,
      sortby_option: true,
      review_option: false,
      reviews_option: false,
      schoolsList: [],
      filteredList: [],
      classificationList: [],
      distList: [],
      facilitesList: [],
      feeList: [],
      fees_option: false,
      error: false,
      filters: { facilities: [], review: '' },
      distanceList: [],
      pages: [1],
      lat: localStorage.getItem("latitude") ? localStorage.getItem("latitude") : CENTERLAT,
      lng: localStorage.getItem("longitude") ? localStorage.getItem("longitude") : CENTERLNG,
      current_location: localStorage.getItem("current_location") ? localStorage.getItem("current_location") : 'bengaluru',
      page_number: 1,
      perpage: PAGI_PERPAGE,
      currentpage: 1,
      distance: DEFAULT_DIS,
      distance_change: false,
      annual_fee: DEFAULT_FEE_OTHER,
      annual_fee_change: false,
      disMax: MAXDIS_FIL,
      priceMax: MAXFEE_FILPlay1,
      reviewList: [],
      catelist: [],
      current_category: '',
      //active_cate: '',
      //active_cate: localStorage.getItem("sub_type") ? localStorage.getItem("sub_type"):'Sports',
      active_cate: localStorage.getItem("hobsub_main_link") ? localStorage.getItem("hobsub_main_link") : '',
      //  sub_categories: this.props.match.params.sub,
      sub_categories: localStorage.getItem("hobsub_main_link_id") ? localStorage.getItem("hobsub_main_link_id") : this.props.match.params.sub,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      schooltypeList: [],
      curriculam_arrow: 'fa-angle-down',
      ptype_arrow: 'fa-angle-down',
      patype_check: [],
      curriculam_option: false,
      categorySubTypeList: [],
      cat_type: false,
      selectedLType: [],
      selectedClass: [],
      partner_type: [],
      totalPages: 0,
      totalResults: 0,
      isloading: true,
      filter_toggle: false,
      type_texts: [],
      learninglocation_texts: [],
      classfrequency_texts: [],
      location_texts: [],
      fees_texts: [],
      ratings_texts: [],
      googleratings_texts: [],
      filter_sort: false,
      sortby: '',
      user_id: 0,
      afterschoolSEOContent:'',
      logged_auth: localStorage.getItem("logged_auth") ? localStorage.getItem("logged_auth") : false,
    };

    this.onChangePage = this.onChangePage.bind(this);
    this.filterToogle = this.filterToogle.bind(this);
    this.getfacilities(); this.getschool_type(); this.getClassFre();
    this.handleDistanceChange = this.handleDistanceChange.bind(this);
    this.handleAnnualfeeChange = this.handleAnnualfeeChange.bind(this);
    this.handleRatingChange = this.handleRatingChange.bind(this);
    this.onStarClickSocial = this.onStarClickSocial.bind(this);
    this.onRemoveTagC = this.onRemoveTagC.bind(this);
    this.onRemoveTagL = this.onRemoveTagL.bind(this);
    this.onRemoveTagGR = this.onRemoveTagGR.bind(this);
    this.onRemoveTagAF = this.onRemoveTagAF.bind(this);
    this.onRemoveTagFees = this.onRemoveTagFees.bind(this);
    this.removeAllCache = this.removeAllCache.bind(this);
    this.onRemoveTagCF = this.onRemoveTagCF.bind(this);
    this.onRemoveTagT = this.onRemoveTagT.bind(this);
    this.setSeoContent = this.setSeoContent.bind(this);

          
    this.enquireThis = this.enquireThis.bind(this);
    this.handleCloseCp = this.handleCloseCp.bind(this);
    this.handleChange = this.handleChange.bind(this);
    
    this.enquireThisRegOnly = this.enquireThisRegOnly.bind(this);
    this.enquireThisPaidOnly = this.enquireThisPaidOnly.bind(this);
  }



  enquireThisRegOnly  = (e) => {

    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {

    let name = $(e.target).attr('data-name');
    let id = $(e.target).attr('data-id');
    this.setState({showcp:true, userType:"registeredonly", orgName:name, id:id});

    }
    else{
      let toastr = '';
      toastr = window.toastr.warning; //warning
      toastr('Sign up with us to enable this feature', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
    }

  } 
  
  enquireThisPaidOnly  = (e) => {

    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {

    let name = $(e.target).attr('data-name');
    let id = $(e.target).attr('data-id');
    this.setState({showcp:true, userType:"paidalso", orgName:name, id:id});

    }
    else{
      let toastr = '';
      toastr = window.toastr.warning; //warning
      toastr('Sign up with us to enable this feature', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
    }

  }
  

  onRemoveTagT = (idx, item, e) => {

    let curriculamdata = sessionStorage.getItem('type_texts').split(',');
    curriculamdata.splice(idx, 1);
    sessionStorage.setItem('type_texts', curriculamdata.toString());
    let c = this.state.partner_type;
    c.splice(idx, 1);
    this.setState({
      partner_type: c
    });

    let curriculam_ids = sessionStorage.getItem('type_ids').split(',');
    curriculam_ids.splice(idx, 1);
    sessionStorage.setItem('type_ids', curriculam_ids.toString());

    this.unCheck('partner_type', idx);
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, partner_type);


  };

  onRemoveTagCF = (idx, item, e) => {

    let curriculamdata = sessionStorage.getItem('classification_texts').split(',');
    curriculamdata.splice(idx, 1);
    sessionStorage.setItem('classification_texts', curriculamdata.toString());
    let c = this.state.classification;
    c.splice(idx, 1);
    this.setState({
      classification: c
    });

    let curriculam_ids = sessionStorage.getItem('classification_ids').split(',');
    curriculam_ids.splice(idx, 1);
    sessionStorage.setItem('classification_ids', curriculam_ids.toString());

    this.unCheck('classification', idx);
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);


  };

  onRemoveTagAF = (idx, item, e) => {

    let curriculamdata = sessionStorage.getItem('affilation_texts').split(',');
    curriculamdata.splice(idx, 1);
    sessionStorage.setItem('affilation_texts', curriculamdata.toString());
    let c = this.state.affilation;
    c.splice(idx, 1);
    this.setState({
      affilation: c
    });

    let curriculam_ids = sessionStorage.getItem('affilation_ids').split(',');
    curriculam_ids.splice(idx, 1);
    sessionStorage.setItem('affilation_ids', curriculam_ids.toString());

    this.unCheck('affilation', idx);
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);


  };

  onRemoveTagGR = (idx, item, e) => {
    let googleratingsdata = sessionStorage.getItem('googleratings_texts').split(',');
    googleratingsdata.splice(idx, 1);

    const reviewRange = document.querySelector("#myRangeSocialRatingWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);
    range.value = 0;

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ review_social: 0 });

    sessionStorage.setItem('googleratings_texts', googleratingsdata.toString());
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);

  };

  onRemoveTagFees = (idx, item, e) => {
    let feesdata = sessionStorage.getItem('fees_texts').split(',');
    feesdata.splice(idx, 1);
    sessionStorage.setItem('fees_texts', feesdata.toString());

    const reviewRange = document.querySelector("#myRangeAnnualFeeWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {
      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ annual_fee: DEFAULT_FEE });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);

  };

  onRemoveTagR = (idx, item, e) => {
    let ratingsdata = sessionStorage.getItem('ratings_texts').split(',');
    ratingsdata.splice(idx, 1);

    const reviewRange = document.querySelector("#myRangeReviewWrap");

    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {

      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ review: 0 });

    sessionStorage.setItem('ratings_texts', ratingsdata.toString());
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, 0, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);

  };

  onRemoveTagL = (item, e) => {

    let locationdata = sessionStorage.getItem('location_texts');

    sessionStorage.setItem('location_texts', '');

    const reviewRange = document.getElementById("myRangeDistanceWrap");
    const range = reviewRange.querySelector(".slider");
    const bubble = reviewRange.querySelector(".bubble");
    range.addEventListener("input", () => {
      setBubble(range, bubble);
    });
    setBubble(range, bubble);

    function setBubble(range, bubble) {

      const val = range.value;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    this.setState({ address: '' });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);

  };

  onRemoveTagC = (idx, item, e) => {

    let curriculamdata = sessionStorage.getItem('curriculam_texts').split(',');
    curriculamdata.splice(idx, 1);
    sessionStorage.setItem('curriculam_texts', curriculamdata.toString());
    let c = this.state.curriculam;
    c.splice(idx, 1);
    this.setState({
      curriculam: c
    });

    let curriculam_ids = sessionStorage.getItem('curriculam_ids').split(',');
    curriculam_ids.splice(idx, 1);
    sessionStorage.setItem('curriculam_ids', curriculam_ids.toString());

    let s = this.state.selectedCurriculam;
    s.splice(idx, 1);
    this.setState({
      selectedCurriculam: s
    });

    this.unCheck('curriculam', idx);
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);


  };

  unCheck = (classname, index) => {

    var x = document.getElementsByName(classname);
    for (var i = 0; i <= x.length; i++) {
      if (index == i) {
        x[i].checked = false;
      }
    }
  }

  removeAllCache = () => {

    sessionStorage.setItem('curriculam_texts', '');
    sessionStorage.setItem('curriculam_ids', '');

    sessionStorage.setItem('type_texts', '');

    sessionStorage.setItem('type_ids', '');

    sessionStorage.setItem('location_texts', '');

    sessionStorage.setItem('fees_texts', '');

    sessionStorage.setItem('ratings_texts', '');

    sessionStorage.setItem('googleratings_texts', '');

    sessionStorage.setItem('facilities_texts', '');
    sessionStorage.setItem('facilities_ids', '');


    var x = document.getElementsByName('curriculam');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    var x = document.getElementsByName('type');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    var x = document.getElementsByName('classification');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    var x = document.getElementsByName('facilities');
    for (var i = 0; i < x.length; i++) {
      x[i].checked = false;
    }

    const allRanges = document.querySelectorAll(".range-wrap");

    allRanges.forEach(wrap => {
      const range = wrap.querySelector(".slider");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
      range.value = 0;
    });

    function setBubble(range, bubble) {
      const val = 0;
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }

    //this.setState({review:0,review_social:0, distance:0, annual_fee:0});

    this.getPreSchoolList();

  };

  updateStyleOfFee() {
    const allRanges = document.querySelectorAll(".range-wrap");

    allRanges.forEach(wrap => {
      const range = wrap.querySelector(".slider");
      const bubble = wrap.querySelector(".bubble");
      range.addEventListener("input", () => {
        setBubble(range, bubble);
      });
      setBubble(range, bubble);
    });

    function setBubble(range, bubble) {
      const val = range.value;
      console.log('setBubble', val)
      const min = range.min ? range.min : 0;
      const max = range.max ? range.max : 100;
      const newVal = Number(((val - min) * 100) / (max - min));
      bubble.innerHTML = val;
      // Sorta magic numbers based on size of the native UI thumb
      bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
    }
  }

  handleDistanceChange = (e) => {
    let distance = e.target.value;
    this.setState({
      distance: e.target.value,
    });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);
  }
  handlePtypeCheck = (e) => {
    let partner_type;
    var checkboxes = document.querySelectorAll('input[name="partner_type"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });
    values = values.filter(n => n);
    var type_texts = []
    Array.prototype.forEach.call(checkboxes, function (el) {
      type_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('type_texts', type_texts.toString());
    sessionStorage.setItem('type_ids', values.toString());

    partner_type = values;
    this.setState({
      partner_type: partner_type,
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, partner_type);
  }


  handleAnnualfeeChange = (e) => {
    let annual_fee = e.target.value;

    let fees_texts = [];
    fees_texts.push(annual_fee);

    this.setState({
      annual_fee: e.target.value, fees_texts: fees_texts
    });

    sessionStorage.setItem('fees_texts', fees_texts.toString());

    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);
  }


  handleRatingChange = (e) => {
    let ratings_texts = [];
    let review = e.target.value;
    ratings_texts.push(review);
    this.setState({
      review: e.target.value, ratings_texts: ratings_texts
    });

    sessionStorage.setItem('ratings_texts', ratings_texts.toString());

    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);
  }

  onStarClickSocial = (e) => {
    let googleratings_texts = [];
    let probName = e.target.name;
    const filterValue = e.target.value;
    googleratings_texts.push(filterValue);
    this.setState({ [probName]: filterValue, googleratings_texts: googleratings_texts });
    sessionStorage.setItem('googleratings_texts', googleratings_texts.toString());
    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, filterValue, this.state.partner_type);
  }


  handleLearningCheckbox = (e) => {
    let affilation;
    var affilation_texts = []
    var checkboxes = document.querySelectorAll('input[name="affilation"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });

    Array.prototype.forEach.call(checkboxes, function (el) {
      affilation_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('affilation_texts', affilation_texts.toString());
    sessionStorage.setItem('affilation_ids', values.toString());

    affilation = values;
    this.setState({
      affilation: values,
      affilation_texts: affilation_texts,
      selectedLType: values,
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);
  }

  handleClassFeqChange = (e) => {
    let classification;
    var classification_texts = []
    var checkboxes = document.querySelectorAll('input[name="classification"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });

    Array.prototype.forEach.call(checkboxes, function (el) {
      classification_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('classification_texts', classification_texts.toString());
    sessionStorage.setItem('classification_ids', values.toString());

    classification = values;
    this.setState({
      classification: values,
      classification_texts: classification_texts,
      selectedClass: values
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);
  }

  handleCurriculamCheckbox = (e) => {
    let curriculam;
    var curriculam_texts = []

    var checkboxes = document.querySelectorAll('input[name="curriculam"]:checked'), values = [];
    Array.prototype.forEach.call(checkboxes, function (el) {
      values.push(el.value);
    });

    Array.prototype.forEach.call(checkboxes, function (el) {
      curriculam_texts.push(el.getAttribute('datatext'));
    });

    sessionStorage.setItem('curriculam_texts', curriculam_texts.toString());
    sessionStorage.setItem('curriculam_ids', values.toString());

    curriculam = values;
    this.setState({
      curriculam: values,
    });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);


  }

  handle_sortby_list = (e, val) => {
    let sortby = e ? e.target.value : val;
    let sort_order = 1;

    this.setState({
      sortby: sortby,
      sort_order: 1,
      sortby_option: true
    });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, sortby, sort_order, this.state.review_social, this.state.partner_type, 1);
  }
  handlePerPage = (e) => {
    let perpage = e.target.value;

    this.setState({ perpage })

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type, 1, '', '', '', perpage);
  }
  handle_Sortby = (e) => {
    this.setState((prevState) => ({
      sortby_option: !prevState.sortby_option,
    }));
    this.handle_SortIcon();
  };


  handle_SortIcon() {
    let sort_order = 0;
    if (this.state.sortby_option == true) {
      sort_order = 2;
    } else if (this.state.sortby_option == false) {
      sort_order = 1;
    }
    alert(sort_order)
    this.setState({
      sort_order: sort_order
    });
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, sort_order, this.state.review_social, this.state.partner_type, 1);
  }
  partnerType = (e) => {
    const propName = e.target.name;
    const partner_type = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({ [propName]: partner_type });
    this.setState({
      partner_type: partner_type,
    });

    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, partner_type);
  }

  typBoxChanged = (e) => {
    const val = [...e.target.selectedOptions].map((item) => item.value);
    this.setState({
      selectedLType: val,
      affilation: val,
    });
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      learning_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      curriculam_option: false,
      learn_arrow: 'fa-angle-down',
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, val, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type);

  }
 

  onChangePrevPage = (page_number) => {
    this.setState({
      pgnumber: page_number,
      currentpage: page_number
    })
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type, page_number, '-');
  }

  onChangeNextPage = (page_number) => {
    this.setState({
      pgnumber: page_number,
      currentpage: page_number
    })
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type, page_number, '+');
  }




  enquireThis = (e) => {

    let name = $(e.target).attr('data-name');
    let id = $(e.target).attr('data-id');
    this.setState({showcp:true, orgName:name, id:id});
  }

  handleCloseCp(){
    this.setState({showcp:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };  

  
  handleSubmitEnquiry = (e) => {

    e.preventDefault();

    let reviewData = JSON.stringify({
      to_email: this.state.email_id,
      user_name: this.state.first_name+" "+this.state.last_name,
      vendor_id : this.state.id,
      vendor_name: this.state.orgName,
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      vertical: "afterschoolactivities",
      location:this.state.current_location,
      any_message: this.state.any_message,
      reg_email:this.state.reg_email,
      reg_mobile:this.state.reg_mobile,
      lead:"enquiry"
    });
    

    saveEnqLead(reviewData).then((response) => {
      if (response.status == 1) {
        
        this.setState({ showcp: false });

        let toastr = '';
          toastr = window.toastr.success; //warning
          toastr('Message sent to the Provider', {
          positionClass: "toast-bottom-center",
          containerId: "toast-bottom-center"  
        });


      }
    });
 
  };


  handleFilterChangeV1(distance, annual_fee, review, classification, affilation, sub_categories, curriculam, sortby, sort_order, review_social, partner_type = '', page_number = 1, operators = '', lat = '', lng = '', perpage) {

    let temppgnum = (this.state.pgnumber == 0) ? 0 : this.state.pgnumber;
    perpage = perpage ? perpage : this.state.perpage;

    this.setState({isloading:true});

    
    if (operators == '+') {

      temppgnum = parseInt(temppgnum) + 15;
      this.setState({
        pgnumber: temppgnum,
        pageindex: this.state.pageindex + 1
      });

    } else if (operators == '-') {

      temppgnum = parseInt(temppgnum) - 15;
      this.setState({
        pgnumber: temppgnum,
        pageindex: this.state.pageindex - 1
      });
    }


    let filterData = JSON.stringify({
      current_latitude: lat ? lat : this.state.lat,
      current_longitude: lng ? lng : this.state.lng,
      distance: distance,
      location:this.state.current_location,
      annual_fee: annual_fee,
      review: review,
      classification: classification,
      affilation: affilation,
      sub_categories: this.state.subcategory_id,
      curriculam: curriculam,
      sortby: sortby,
      sort_order: sort_order,
      review_social: review_social,
      partner_type: partner_type,
      page_number: page_number ? page_number : this.state.page_number,
      offset: parseInt(temppgnum),
      sub_category_keyword: this.state.current_category,
      perpage: perpage,
      vertical: 'afterschoolactivities'
    });

    verticalTotalCount(filterData).then((response) => {

      this.setState({
        totalrecords: response.data
      });

      let divided = Math.ceil(response.data / perpage);

      this.setState({
        totalsplitpages: divided
      });


    });

    verticalListing(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list);
      } else if (response.status == 0) {
        this.setState({
          totalPages: 0,
          isloading: false
        });
      }
    });

    /* 
      hobbiesSecondSubFilter(filterData).then((response) => {
        if (response.status == 1) {
          const list = response;
          this.setPage(list, page_number);
        } else if (response.status == 0) {
          this.setState({
            filteredList: [],
            pageOfItems: [],
            totalPages: 0,
            isloading: false
          });
        }
      });
    */

  }


  handleFilterChange(distance, annual_fee, review, classification, affilation, sub_categories, curriculam, sortby, sort_order, review_social, partner_type = '', page_number = 1, lat = '', lng = '') {

    let filterData = JSON.stringify({
      current_latitude: lat ? lat : this.state.lat,
      current_longitude: lng ? lng : this.state.lng,
      location:this.state.current_location,
      distance: distance,
      annual_fee: annual_fee,
      review: review,
      classification: classification,
      affilation: affilation,
      sub_categories: this.state.subcategory_id,
      curriculam: curriculam,
      sortby: sortby,
      sort_order: sort_order,
      review_social: review_social,
      partner_type: partner_type,
      page_number: page_number ? page_number : this.state.page_number,
      perpage: PAGI_PERPAGE
    });

    hobbiesSecondSubFilter(filterData).then((response) => {
      if (response.status == 1) {
        const list = response;
        this.setPage(list, page_number);
      } else if (response.status == 0) {
        this.setState({
          filteredList: [],
          pageOfItems: [],
          totalPages: 0,
          isloading: false
        });
      }
    });
  }
  setPage(list, page_number = '') {
    let data = list.data;
    let total_pages = list.total_pages;
    this.setState({
      filteredList: data,
      pageOfItems: data,
      totalPages: total_pages,
      currentpage: page_number != '' ? page_number : 1,
      page_number: page_number != '' ? page_number : 1,
      totalResults: list.length,
      isloading: false
    });
  }
  componentDidUpdate() {
    // let current = window.jQuery(".page-item.page-number.active").find('a').html();
    // console.log('current', current)
    // if ((current) && this.state.currentpage != current) {
    //   this.setState({
    //     currentpage: current
    //   })
    // }
  }
  componentDidUpdate() {

    var cards = $(".premiumuser");
    for(var i = 0; i < cards.length; i++){
      var target = Math.floor(Math.random() * cards.length -1) + 1;
      var target2 = Math.floor(Math.random() * cards.length -1) +1;
      cards.eq(target).before(cards.eq(target2));
    }
    
    //window.jQuery('.selectpicker').selectpicker('refresh');
  }


  setSeoContent(){

        if(this.props.match.params.subcategory2=='quizzes'){


        let html = `<p>Searching for quiz classes /online e-quizz&nbsp; in Bangalore?&nbsp;</p>

<p>Find best quiz classes in Bangalore&nbsp;</p>

<p>Search and choose best quiz contest/ quiz classes near me&nbsp;</p>

<p>Quizzes encourage Students self-assessment. By taking quizzes, Kids can get instant feedback on their responses. And this can help them identify areas they need to develop themselves and highlight progress for them to be proud of. So, checkout some list of online quiz contest and classes with BeWise. Choose the <a href="https://www.bewise.in/bengaluru/after-school-activity/hobbies-and-passion/quizzes" rel="noreferrer noopener" target="_blank">best quiz solving class in bangalore</a> for your child. Did you try the latest filter feature at BeWise, wherein you can find the <a href="https://www.bewise.in/best-hobby-passion-enriching-classes-near-me" rel="noreferrer noopener" target="_blank">Best Hobby and Passion Classes Near me</a> at 3 simple steps.&nbsp;</p>`;

        this.setState({afterschoolSEOContent:html});

    }
    if(this.props.match.params.subcategory2=='story-telling'){


        let html = `<p>Learn Story telling from beginners to advance in Bangalore?&nbsp;</p>

<p>Find best Story telling classes in Bangalore&nbsp;</p>

<p>Search and choose best Story telling classes near me&nbsp;</p>

<p>Storytelling brings language learning alive and creates a participatory and immersive experience that allows Young Learners to enjoy hearing the language in a dynamic, sometimes stylistic and entertaining way. Participation using key vocabulary and phrases can create an awareness of rhythm and structure. Check out the list of <a href="https://www.bewise.in/bengaluru/after-school-activity/hobbies-and-passion/story-telling" rel="noreferrer noopener" target="_blank">best story telling classes in Bangalore</a> with BeWise. Did you try the latest filter feature at BeWise, wherein you can find the <a href="https://www.bewise.in/best-hobby-passion-enriching-classes-near-me" rel="noreferrer noopener" target="_blank">Best Hobby and Passion Classes Near me</a> at 3 simple steps.&nbsp;</p>

<p>Signup now to join best Story telling classes fees near me&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    
    if(this.props.match.params.subcategory2=='cooking-and-baking'){


        let html = `<p>Looking for cooking and baking classes for beginners to advance in Bangalore?&nbsp;</p>

<p>Find best cooking classes in Bangalore| Find best Baking classes in Bangalore&nbsp;</p>

<p>Search and choose best cooking and baking classes near me&nbsp;</p>

<p>Signup now to join best cooking classes near me| best baking classes near me&nbsp;</p>

<p>Learn how to cook food or learn baking skills in Bangalore with the help of best cooking trainer. Explore the world of taste by learning cooking and baking with BeWise. Enjoy and learn to cook and bake your favourite recipes with BeWise. Check out the list of <a href="https://www.bewise.in/bengaluru/after-school-activity/hobbies-and-passion/cooking-and-baking" rel="noreferrer noopener" target="_blank">best cooking classes in Bangalore</a> and baking classes&rsquo; fees near me in Bangalore. Did you try the latest filter feature at BeWise, wherein you can find the <a href="https://www.bewise.in/best-hobby-passion-enriching-classes-near-me" rel="noreferrer noopener" target="_blank">Best Hobby and Passion Classes Near me</a> at 3 simple steps.&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='theatre'){


        let html = `<p>An improvised or purposely chosen sequence of movement constitutes a dance. Dance has both aesthetic and symbolic value. Choreography, a repertoire of movements, or historical periods or places can be used to categorize or describe it. Unlike theater, which is a collaborative performance involving live performers that depicts a real or imagined event at a particular venue. This is usually on stage. In addition to gestures, speech, songs, and music, performers can use dance to convey this experience to the audience. &nbsp;</p>

<p>Choose Best Dance Classes Near Me | Top Dance Classes in Bangalore | Select the Best Theater Academy Near Me in Bangalore | Top Theater Academy Near Me | Best Dance Classes Near Me &nbsp;</p>

<p>Signup now for the Best Dance Classes and Theater Academy Near Me &nbsp;</p>

<p>Are you searching for the Best Dance Classes and Theater in Bangalore?&nbsp;</p>`;

        this.setState({afterschoolSEOContent:html});

    }


    if(this.props.match.params.subcategory2=='singing-classes'){


        let html = `<p>Looking for best singing classes in Bangalore? &nbsp;</p>

<p>Searching for best Carnatic music classes near me / classical singing classes near me&nbsp;</p>

<p>Find and choose best vocal music classes for all age group in Bangalore&nbsp;</p>

<p>Learning a new skill can be challenging, and searching the best vocal music classes near me location can bigger challenge for any parents. Here&#39;s a list of <a href="https://www.bewise.in/bengaluru/after-school-activity/music/singing-classes" rel="noreferrer noopener" target="_blank">best vocal music classes in Bangalore</a> for different type of music classes like Carnatic music, Indian Classical music classes or normal vocal light music classes. Search and choose the best option of <a href="https://www.bewise.in/best-music-classes-near-me" rel="noreferrer noopener" target="_blank">music classes near me</a>. Learn singing from the best vocal music trainer in Bangalore. Explore the best vocal music classes in our portal, checkout the parent reviews, fees, infrastructure etc. choose the <a href="https://www.bewise.in/bengaluru/after-school-activity/music/singing-classes" rel="noreferrer noopener" target="_blank">singing classes near me</a> with fees, location and timing. Get the best list of online and offline singing classes in Bangalore.&nbsp;&nbsp;</p>`;
        
        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='instrumental'){

        let html = `<p>Looking for Best Instrument classes for your child? &nbsp;</p>

<p>Find and choose best Instrument music classes for all age group in Bangalore&nbsp;</p>

<p>Are you looking for best guitar classes in Bangalore/guitar classes near me/Best Piano classes in Bangalore/piano classes near me/Best Flute classes near me or search for best violin classes near me in BeWise.&nbsp;</p>

<p>Learn to play instrumental music lessons and notes from experienced musicians, teachers, and tutors in Bangalore. Choose the <a href="https://www.bewise.in/bengaluru/after-school-activity/music/instrumental" rel="noreferrer noopener" target="_blank">best instrument classes near me</a> locations. Explore the best instrument music classes (Guitar classes near me, violin classes near me, piano classes near me, and keyboard classes near me) in our portal, checkout the parent reviews, fees, infrastructure etc. choose the <a href="https://www.bewise.in/best-music-classes-near-me" rel="noreferrer noopener" target="_blank">best music classes near me</a> with fees, location and timing. Get the best list of online and offline instrument classes in Bangalore.&nbsp;&nbsp;</p>
`;


        this.setState({afterschoolSEOContent:html});      
      
    }

    
    if(this.props.match.params.subcategory2=='football'){

        let html=`<p>Choose Best Football Academy in `+this.props.match.params.city+` | Top Football Coaching Classes in `+this.props.match.params.city+` | Select the Best Football Academy Near Me in `+this.props.match.params.city+` | Top Football Coaching Classes Near Me | Best Football Academy Near Me&nbsp;</p>

<p>Signup now for the Best Football Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Football Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>In addition to being a popular game around the world, football is also known as soccer and is known for its thrilling action and strategy. Besides the obvious excitement generated by football action, there are tons of other benefits to this game. It is perhaps the most obvious benefit of football to students. When learners often participate, they workout their bodies, leading to improvements in fitness levels. For parents looking for &quot;best football coaching academies near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/football" rel="noreferrer noopener" target="_blank">best football academies in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='tennis'){

       let html=`<p>Choose Best Tennis Academy in `+this.props.match.params.city+` | Top Tennis Coaching Classes in `+this.props.match.params.city+` | Select the Best Tennis Academy Near Me in `+this.props.match.params.city+` | Top Tennis Coaching Classes Near Me | Best Tennis Academy Near Me&nbsp;</p>

<p>Signup now for the Best Tennis Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Tennis Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Australia has a large population of tennis fans. In tennis, two people can play singles or four people can play doubles. Tennis involves a variety of plays, including serving the ball over the net, rallies, fast movement, and strategic play. An hour-long game helps burn around 600 calories in men and 420 calories in women. With numerous social and mental health benefits it provides fitness and physical health. For parents looking for &quot;top tennis classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/tennis" rel="noreferrer noopener" target="_blank">best tennis classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    

    if(this.props.match.params.subcategory2=='cricket'){

        let html=`<p>Choose Best Cricket Academy in `+this.props.match.params.city+` | Top Cricket Coaching Classes in `+this.props.match.params.city+` | Select the Best Cricket Academy Near Me in `+this.props.match.params.city+` | Top Cricket Coaching Classes Near Me | Best Cricket Academy Near Me&nbsp;</p>

<p>Signup for the Best Cricket Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Cricket Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Cricket is the most popular sport in the world. Originally from England, it is popular in countries like India, Pakistan, Sri Lanka, Australia, the West Indies, and South Africa. A team of two players bats, fields, and bowls on an oval. It can take several hours or days to complete a game with 11 players each side. If you&#39;re interested in playing competitively, you should join a club. For parents looking for &quot;top cricket coaching academies near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/cricket" rel="noreferrer noopener" target="_blank">best cricket classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='swimming'){

        let html=`<p>Choose Best Swimming Academy in `+this.props.match.params.city+` | Top Swimming Coaching Classes in `+this.props.match.params.city+` | Select the Best Swimming Academy Near Me in `+this.props.match.params.city+` | Top Swimming Coaching Classes Near Me | Best Swimming Academy Near Me&nbsp;</p>

<p>Signup now for the Best Swimming Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Swimming Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Australia has one of the highest levels of swimmers. Swimming is one of our greatest passions since we are surrounded by water. Keeping fit, staying healthy, and making friends are all benefits of swimming. It is a good way to relax and feel good while getting a low-impact workout from recreational swimming. There are several common swimming styles in recreational swimming, including breaststroke, backstroke, sidestroke, and freestyle. For parents looking for &quot;best swimming classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/swimming" rel="noreferrer noopener" target="_blank">best swimming classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='hockey'){

        let html=`<p>Choose Best Swimming Academy in `+this.props.match.params.city+` | Top Swimming Coaching Classes in `+this.props.match.params.city+` | Select the Best Swimming Academy Near Me in `+this.props.match.params.city+` | Top Swimming Coaching Classes Near Me | Best Swimming Academy Near Me&nbsp;</p>

<p>Signup now for the Best Swimming Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Swimming Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Hockey is a great sport for losing weight in a fun way or promoting a positive body image in your son or daughter while strengthening their mind and body. Increasing muscle mass contributes to long-term benefits as short bursts of energy burn maximum calories. Hockey also improves lung capacity and cellular activity throughout the body as a result of its cardiovascular nature. For parents looking for &quot;best hockey coaching center near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/hockey" rel="noreferrer noopener" target="_blank">best hockey classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='badminton'){

        let html=`<p>Choose Best Badminton Academy in `+this.props.match.params.city+` | Top Badminton Coaching Classes in `+this.props.match.params.city+` | Select the Best Badminton Academy Near Me in `+this.props.match.params.city+` | Top Badminton Coaching Classes Near Me | Best Badminton Academy Near Me&nbsp;</p>

<p>Signup now for the Best Badminton Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Badminton Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Racquet sports like badminton are played by hitting a shuttlecock across a net with racquets. Singles and doubles are the most common forms of the game, although larger teams may also participate. In informal games, badminton is played on a rectangular indoor court or in a yard; in formal games, it is played on the beach or in a yard. For parents looking for &quot;best badminton classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/badminton" rel="noreferrer noopener" target="_blank">best badminton classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='gymnastics'){

        let html=`<p>Choose Best Gymnastics Sports Academy in `+this.props.match.params.city+` | Top Gymnastics Coaching Academy in `+this.props.match.params.city+` | Select the Best Gymnastics Academy Near Me in `+this.props.match.params.city+` | Top Gymnastics Coaching Academy Near Me | Best Gymnastics Academy Near Me&nbsp;</p>

<p>Signup now for the Best Gymnastics Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Gymnastics Sports Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>As a sport, gymnastics requires balance, strength, flexibility, agility, coordination, dedication, and endurance. Gymnastics exercises develop the arms, legs, shoulders, back, chest, and abdominal muscles. Ancient Greeks used gymnastics to mount and dismount horses, and circus performers used it to perform. Athletes of all skill levels participate in gymnastics-related sports, including young children and recreational athletes. For parents looking for &quot;best gymnastics academy near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/gymnastics" rel="noreferrer noopener" target="_blank">best gymnastics academies in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='athletics-running'){

        let html=`<p>Choose Best Athletics Academy in `+this.props.match.params.city+` | Top Athletics Coaching Academy in `+this.props.match.params.city+` | Select the Best Athletics Academy Near Me in `+this.props.match.params.city+` | Top Athletics Sports Academy Near Me | Best Athletics Academy Near Me&nbsp;</p>

<p>Signup now for the Best Athletics Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Athletics Sports Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Athletes compete in running, jumping, throwing, and walking. Typical athletic competitions include track and field, road running, cross country running, and racewalking. A race is decided by finishing position, whereas jumps and throws are decided by the athlete who achieves the highest or farthest measurement. It is the most popular type of sport in the world due to the simplicity of the competitions. For parents looking for &quot;best athletics academy near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/athletics-running" rel="noreferrer noopener" target="_blank">best athletics academies in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='boxing-wrestling'){

        let html=`<p>Choose Best Boxing and Wrestling Academy in `+this.props.match.params.city+` | Top Boxing and Wrestling Coaching Classes in `+this.props.match.params.city+` | Select the Best Boxing and Wrestling Academy Near Me in `+this.props.match.params.city+` | Top Boxing and Wrestling Coaching Academy Near Me | Best Boxing and Wrestling Academy Near Me&nbsp;</p>

<p>Signup now for the Best Boxing and Wrestling Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Boxing and Wrestling Coaching Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>A variety of wrestling techniques exist, including freestyle, Greco-Roman, judo, sambo, folkstyle, catch, submission, sumo, pehlwani, shuai jiao, etc. In wrestling, two (or more) competitors attempt to gain and maintain a position in a physical contest. For parents looking for &quot;<a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/boxing-wrestling" rel="noreferrer noopener" target="_blank">best boxing classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/boxing-wrestling" rel="noreferrer noopener" target="_blank">best wrestling classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }

    if(this.props.match.params.subcategory2=='martial-arts-karate'){

        let html=`<p>Choose Best Karate and Martial Arts Academy in `+this.props.match.params.city+` | Top Karate and Martial Arts Coaching Classes in `+this.props.match.params.city+` | Select the Best Karate and Martial Arts Academy Near Me in `+this.props.match.params.city+` | Top Karate and Martial Arts Coaching Classes Near Me | Best Karate and Martial Arts Academy Near Me&nbsp;</p>

<p>Signup now for the Best Karate and Martial Arts Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Karate and Martial Arts Coaching Classes in `+this.props.match.params.city+`?&nbsp;</p>

<p>Karate is an ancient martial art. A majority of karate techniques are strike-based, including punching, kicking, knee strikes, elbow strikes and open-hand techniques such as knife-hands, spear-hands, and palm-heel strikes. For parents looking for &quot;best martial arts classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/martial-arts-karate" rel="noreferrer noopener" target="_blank">best karate classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    }                

    if(this.props.match.params.subcategory2=='trekking-rock-climbing'){

        let html=`<p>Choose Best Trekking and Rock Climbing in `+this.props.match.params.city+` | Top Trekking and Rock Climbing in `+this.props.match.params.city+` | Select the Best Trekking and Rock Climbing Near Me in `+this.props.match.params.city+` | Top Trekking and Rock Climbing Near Me | Best Trekking and Rock Climbing Near Me&nbsp;</p>

<p>Signup now for the Best Trekking and Rock Climbing Near Me&nbsp;</p>

<p>Are you searching for the Best Trekking and Rock Climbing in `+this.props.match.params.city+`?&nbsp;</p>

<p>Multi-day hiking is often referred to as trekking in mountainous regions such as India,, North America, South America, etc. Participants in rock climbing climb up, across, or down natural rock. The goal is to reach the top of a formation or the endpoint of a predefined route without falling. For parents looking for &quot;best trekking and rock climbing classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/trekking-rock-climbing" rel="noreferrer noopener" target="_blank">best trekking and rock climbing training in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    } 

    if(this.props.match.params.subcategory2=='all-others'){

        let html=``;

        this.setState({afterschoolSEOContent:html});

    }     

    if(this.props.match.params.subcategory2=='chess'){

        let html=`<p>Choose Best Chess Academy in `+this.props.match.params.city+` | Top Chess Coaching Classes in `+this.props.match.params.city+` | Select the Best Chess Academy Near Me in `+this.props.match.params.city+` | Top Chess Coaching Classes Near Me | Best Chess Academy Near Me&nbsp;</p>

<p>Signup now for the Best Chess Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Chess Coaching Classes in `+this.props.match.params.city+`?&nbsp;</p>

<p>Chess is a two-player board game. Millions of people worldwide play chess today, making it one of the most popular games in the world. Chess is an abstract strategy game, with no hidden information. There are 64 squares arranged in an eight-by-eight grid chessboard. During the game, the object is to checkmate the opponent&#39;s king, which is under immediate attack. For parents looking for &quot;best chess coaching classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/chess" rel="noreferrer noopener" target="_blank">best chess classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    } 

    if(this.props.match.params.subcategory2=='basketball'){

        let html=`<p>Choose Best Basketball Academy in `+this.props.match.params.city+` | Top Basketball Coaching Academy in `+this.props.match.params.city+` | Select the Best Basketball Academy Near Me in `+this.props.match.params.city+` | Top Basketball Sports Academy Near Me | Best Basketball Academy Near Me&nbsp;</p>

<p>Signup now for the Best Basketball Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Basketball Coaching Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>As a team sport, basketball involves two teams, usually consisting of five players, who play against each other on a rectangular court. The primary objective is to shoot a basketball through the defender&#39;s hoop mounted at each end of the court. One, two, or three one-point free throws are awarded after a foul or technical foul is committed. For parents looking for &quot;best basketball classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/basketball" rel="noreferrer noopener" target="_blank">best basketball classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    } 


    if(this.props.match.params.subcategory2=='golf'){

        let html=`<p>Choose Best Golf Academy in `+this.props.match.params.city+` | Top Golf Coaching Academy in `+this.props.match.params.city+` | Select the Best Golf Academy Near Me in `+this.props.match.params.city+` | Top Golf Coaching Academy Near Me | Best Golf Sports Academy Near Me&nbsp;</p>

<p>Signup now for the Best Golf Sports Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Golf Coaching Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>A club-and-ball sport, golf involves hitting balls into holes on a course with various clubs. Typically, golf courses have 18 or 9 holes.. An individual or team plays golf to score the lowest number of strokes over a complete round, called stroke play. For parents looking for &quot;best golf sports academy near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/golf" rel="noreferrer noopener" target="_blank">best golf sports academies in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    } 

    if(this.props.match.params.subcategory2=='archery'){

        let html=`<p>Choose Best Archery Sports Academy in `+this.props.match.params.city+` | Top Archery Sports Coaching in `+this.props.match.params.city+` | Select the Best Archery Academy Near Me in `+this.props.match.params.city+` | Top Archery Coaching Academy Near Me | Best Archery Sports Academy Near Me&nbsp;</p>

<p>Signup now for the Best Archery Sports Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Archery Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Archery involves shooting arrows with a bow. The word comes from the Latin arcus, which means bow. Sports and recreational activities are mainly associated with it in modern times. People who practice archery are called archers, bowmen, or toxophilites. PPN A-shouldered Khiam-points and Khiamian points may both be arrowheads. For parents looking for &quot;best archery sports academy near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/archery" rel="noreferrer noopener" target="_blank">best archery sports in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a></p>
`;

        this.setState({afterschoolSEOContent:html});

    } 


    if(this.props.match.params.subcategory2=='go-karting'){

        let html=`<p>Choose Best Go Karting Sports Academy in `+this.props.match.params.city+` | Top Go Karting Coaching Academy in `+this.props.match.params.city+` | Select the Best Go Karting Academy Near Me in `+this.props.match.params.city+` | Top Go Karting Coaching Academy Near Me | Best Go Karting Academy Near Me&nbsp;</p>

<p>Signup now for the Best Go Karting Sports Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Go Karting Coaching Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>Often referred to as simply a kart, the go-kart is a type of sports car, closed-wheel car, open-wheel car, or quadricycle. Non-motorized go-karts as well as high-performance racing karts are available. A gravity go-kart, also known as a soap box derby cart in North America, is the most basic type of go-kart. For parents looking for &quot;go karting sports academy near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/go-karting" rel="noreferrer noopener" target="_blank">best go karting sports academies in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>

<p>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    } 

    if(this.props.match.params.subcategory2=='skating'){

        let html=`<p>Choose Best Skating Academy in `+this.props.match.params.city+` | Top Skating Coaching Classes in `+this.props.match.params.city+` | Select the Best Skating Academy Near Me in `+this.props.match.params.city+` | Top Skating Coaching Classes Near Me | Best Skating Academy Near Me&nbsp;</p>

<p>Signup now for the Best Skating Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Skating Coaching Classes in `+this.props.match.params.city+`?&nbsp;</p>

<p>A sport like skating can never be an easy task. Despite its simplicity, skating is not something to master on its own. A combination of agility, balance, and stamina is required, however, to enhance your grip on the sport along with your physical fitness in a variety of ways. It can be very confusing to choose a skating class, just like any other decision. For parents looking for &quot;skating classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/skating" rel="noreferrer noopener" target="_blank">best skating classes in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});

    } 

    if(this.props.match.params.subcategory2=='table-tennis'){

        let html=`<p>Choose Best Table Tennis Academy in `+this.props.match.params.city+` | Top Table Tennis Sports Coaching in `+this.props.match.params.city+` | Select the Best Table Tennis Sports Academy Near Me in `+this.props.match.params.city+` | Top Table Tennis Coaching Academy Near Me | Best Table Tennis Sports Academy Near Me&nbsp;</p>

<p>Signup now for the Best Table Tennis Academy Near Me&nbsp;</p>

<p>Are you searching for the Best Table Tennis Coaching Academy in `+this.props.match.params.city+`?&nbsp;</p>

<p>There is a net between the table and the net, dividing the table into two halves. Players must allow a ball to bounce on their side of the table. The player scores a point when the ball is not returned within the rules. Lots of action and quick reactions are required. For parents looking for &quot;table tennis sports academies near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in`+this.props.match.params.city+`after-school-activity/sports/table-tennis" rel="noreferrer noopener" target="_blank">best table tennis academies in `+this.props.match.params.city+`</a>. Did you try Bewise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-sports-classes-near-me" rel="noreferrer noopener" target="_blank">best sports classes near me</a>&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});
    }         


    if(this.props.match.params.subcategory2=='bharatnatyam'){

        let html=`<p>Choose Best Bharatnatyam Dance Classes Near Me | Top Bharatnatyam Dance Classes in Bangalore | Select the Best Bharatnatyam Dance Classes Near Me in Bangalore | Top Bharatnatyam Dance Classes Near Me | Best Bharatnatyam Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Bharatnatyam Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Bharatnatyam Dance Classes in Bangalore?&nbsp;</p>

<p>Bharatanatyam is one of the oldest classical dance traditions in India. Bharatanatyam is a state dance form in Tamil Nadu. In Bharatanatyam, banis come in different forms. Banis, or &#39;traditions,&#39; describe dance styles and techniques exclusive to certain gurus or schools. For parents looking for &quot;<a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/bharatnatyam" rel="noreferrer noopener" target="_blank">best bharatnatyam dance classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes in Bangalore</a>.Simply search Bharatanatyam Classical Dance Classes Near Me on Google for best results.&nbsp;</p>
`;

        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='kuchipudi'){

        let html=`<p>Choose Best Kuchipudi Dance Classes Near Me | Top Kuchipudi Dance Classes in Bangalore | Select the Best Kuchipudi Dance Classes Near Me in Bangalore | Top Kuchipudi Dance Classes Near Me | Best kuchipudiDance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Kuchipudi Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Kuchipudi Dance Classes in Bangalore?&nbsp;</p>

<p>Kuchipudi is the only classical style that includes singing. Andhra Pradesh is its home state. The dance-drama Bhama Kalapam, which tells the story of Satyabhama, Krishna&#39;s beautiful but jealous wife, is credited with originating Kuchipudi. For parents looking for &quot;<a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/kuchipudi" rel="noreferrer noopener" target="_blank">best kuchipudi dance classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the best kuchipudi dance classes in Bangalore. A Kuchipudi Classical Dance Class Near Me can be found on Google if you search for it. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature.&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='odissi'){

        let html=`<p>Choose Best Odissi Dance Classes Near Me | Top Odissi Dance Classes in Bangalore | Select the Best Odissi Dance Classes Near Me in Bangalore | Top Odissi Dance Classes Near Me | Best Odissi Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Odissi Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Odissi Dance Classes in Bangalore?&nbsp;</p>

<p>Odissi is an ancient Indian classical dance that originated in the temples of Odisha, an eastern coastal state. In Odissi music, songs are composed and written according to the ragas and talas of the state&#39;s ancient poets. For parents looking for &quot;<a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/odissi" rel="noreferrer noopener" target="_blank">best odissi dance classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the best odissi dance classes in Bangalore. Get the <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance class near me</a> with our filter feature.&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='kathak'){

        let html=`<p>Choose Best Kathak Dance Classes Near Me | Top Kathak Dance Classes in Bangalore | Select the Best Kathak Dance Classes Near Me in Bangalore | Top Kathak Dance Classes Near Me | Best Kathak Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Kathak Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Kathak Dance Classes in Bangalore?&nbsp;</p>

<p>As one of the six classical dance forms of India, Kathak is native to North India. Mahabharata and Ramayana are portrayed in Hindu temples through Kathak. For parents looking for &quot;best kathak dance classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/kathak" rel="noreferrer noopener" target="_blank">best kathak dance classes in Bangalore</a>. You can find relevant results by searching for the best kathak classes near me on Google. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature.</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='bollywood'){

        let html=`<p>Choose Best Bollywood Dance Classes Near Me | Top Bollywood Dance Classes in Bangalore | Select the Best Bollywood Dance Classes Near Me in Bangalore | Top Bollywood Dance Classes Near Me | Best Bollywood Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Bollywood Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Bollywood Dance Classes in Bangalore?&nbsp;</p>

<p>Bollywood dance is one of the best western dance forms used in Indian films. It incorporates many styles including belly dancing, kathak, Indian folk, Western popular, jazz, and even Western erotic dancing. For parents looking for &quot;best Bollywood dance classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/bollywood" rel="noreferrer noopener" target="_blank">best Bollywood dance classes in Bangalore</a>. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature. You can find relevant results by searching for the best Bollywood classes near me on Google.&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='salsa-and-similar-dance'){

        let html=`<p>Choose Best Salsa and Similar Dance Classes Near Me | Top Salsa and Similar Dance Classes in Bangalore | Select the Best Salsa and Similar Dance Classes Near Me in Bangalore | Top Salsa and Similar Dance Classes Near Me | Best Salsa and Similar Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Salsa and Similar Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Salsa and Similar Dance Classes in Bangalore?&nbsp;</p>

<p>Salsa is a Latin dance that originated in New York City in the 1960s. It combines Cuban and American dances like mambo, pachanga, and rumba. For parents looking for &quot;<a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/salsa-and-similar-dance" rel="noreferrer noopener" target="_blank">best salsa dance classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the best salsa and similar dance classes in Bangalore. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature. Search for Salsa Western Dance Classes Near Me on Google to find such a class for your child.&nbsp;&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='hip-hop'){

        let html=`<p>Choose Best Hip Hop Dance Classes Near Me | Top Hip Hop Dance Classes in Bangalore | Select the Best Hip Hop Dance Classes Near Me in Bangalore | Top Hip Hop Dance Classes Near Me | Best Hip Hop Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Hip Hop Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Hip Hop Dance Classes in Bangalore?&nbsp;</p>

<p>It evolved from western dance classes into a form of street dance that can now be performed in dance classes with the best equipment. Street dance crews performed freestyle hip hop dances originally. For parents looking for &quot;best hip hop dance classes near me&quot; for their children, our team at Bewise compiled a list of some of the <a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/hip-hop" rel="noreferrer noopener" target="_blank">best hip hop dance classes in Bangalore</a>. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature. On Google search for Hip Hop Western Dance Classes Near Me.&nbsp;</p>

<p>&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

    if(this.props.match.params.subcategory2=='other-dance-forms'){

        let html=``;
        this.setState({afterschoolSEOContent:html});
        
    }   

 

    if(this.props.match.params.subcategory2=='ballet'){

        let html=`<p>Choose Best Ballet Dance Classes Near Me | Top Ballet Dance Classes in Bangalore | Select the Best Ballet Dance Classes Near Me in Bangalore | Top Ballet Dance Classes Near Me | Best Ballet Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Ballet Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Ballet Dance Classes in Bangalore?&nbsp;</p>

<p>Ballet dance was invented by Italians over 500 years ago. Despite the dancer&#39;s appearance of gentleness and grace, ballet requires strength, balance, technical ability, and flexibility. For parents looking for &quot;<a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/ballet" rel="noreferrer noopener" target="_blank">best ballet dance classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the best ballet dance classes in Bangalore. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature. Simply search Ballet Dance Classes Near Me on Google for best results.&nbsp;</p>

<p>&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   



    if(this.props.match.params.subcategory2=='ballet'){

        let html=`<p>Choose Best Ballet Dance Classes Near Me | Top Ballet Dance Classes in Bangalore | Select the Best Ballet Dance Classes Near Me in Bangalore | Top Ballet Dance Classes Near Me | Best Ballet Dance Classes Near Me&nbsp;</p>

<p>Signup now for the Best Ballet Dance Classes Near Me&nbsp;</p>

<p>Are you searching for the Best Ballet Dance Classes in Bangalore?&nbsp;</p>

<p>Ballet dance was invented by Italians over 500 years ago. Despite the dancer&#39;s appearance of gentleness and grace, ballet requires strength, balance, technical ability, and flexibility. For parents looking for &quot;<a href="https://www.bewise.in/bengaluru/after-school-activity/dance-and-theatre/ballet" rel="noreferrer noopener" target="_blank">best ballet dance classes near me</a>&quot; for their children, our team at Bewise compiled a list of some of the best ballet dance classes in Bangalore. Get the details of <a href="https://www.bewise.in/best-dance-classes-near-me" rel="noreferrer noopener" target="_blank">best dance classes near me</a> with BeWise&rsquo;s filter feature. Simply search Ballet Dance Classes Near Me on Google for best results.&nbsp;</p>

<p>&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

if(this.props.match.params.subcategory2=='drawing-painting'){

  let html=`<p>Register now to choose and join the best Drawing and Painting classes near me&nbsp;</p>

<p>Do you want to learn Drawing or painting from professional?&nbsp;</p>

<p>Join best drawing classes in Bangalore.&nbsp;</p>

<p>Where can I find Painting Classes near me? Find the list of best Drawing and Painting Classes in Bangalore with BeWise. Drawing, painting and sketching these all are comes under a unique feature of any art class. Choose the best drawing and <a href="https://www.bewise.in/bengaluru/after-school-activity/creative-arts/drawing-painting" rel="noreferrer noopener" target="_blank">best painting teachers near me</a> in Bengaluru. Search, compare and select the <a href="https://www.bewise.in/bengaluru/after-school-activity/creative-arts/drawing-painting" rel="noreferrer noopener" target="_blank">best drawing classes near me</a> and painting classes near me with fees structure. Did you try BeWise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-arts-classes-near-me" rel="noreferrer noopener" target="_blank">best art classes near me</a>&nbsp;</p>

`;
        this.setState({afterschoolSEOContent:html});
        
    }   

if(this.props.match.params.subcategory2=='pottery'){
  
let html=`<p>Register now to choose and join the best Pottery classes near me&nbsp;</p>

<p>Do you want to learn Pottery/clay modelling from professional?&nbsp;</p>

<p>Join best Pottery classes in Bangalore&nbsp;</p>

<p>Connect with the earth &amp; let your child learn to play with clay. Clay modelling pottery helps your child to activate their different gross and fine motor skills. Help them to understand and feel the natural clay while mastering hand-building techniques like pinching, coiling &amp; slab making. Let them come up with some beautiful art work from their imagination. Choose the <a href="https://www.bewise.in/bengaluru/after-school-activity/creative-arts/pottery" rel="noreferrer noopener" target="_blank">best Pottery teachers near me</a> in Bengaluru. Search, compare and select the pottery/clay modeling classes near me with fees structure. Did you try BeWise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-arts-classes-near-me" rel="noreferrer noopener" target="_blank">best art classes near me</a>&nbsp;</p>

`;
        this.setState({afterschoolSEOContent:html});
        
    }   

if(this.props.match.params.subcategory2=='arts-crafts'){

let html=`<p>Register now to choose and join the best art and craft classes near me&nbsp;</p>

<p>Do you want to learn art and craft from professional teachers in Bangalore?&nbsp;</p>

<p>Join best art and craft classes in Bangalore&nbsp;</p>

<p>Art and craft activities give kids a sense of achievement and allow them to take pride in their work which builds confidence.  Art and craft is the best way through which any child can communicate an express their thoughts and feelings easily. Art and craft classes also help any child to open their creative mind and encourage them to create something new and beautiful. Choose the <a href="https://www.bewise.in/bengaluru/after-school-activity/creative-arts/arts-crafts" rel="noreferrer noopener" target="_blank">best Art and craft classes in Bengaluru</a>. Search, compare and select the art and craft classes near me with fees structure. Did you try BeWise&rsquo;s filter feature to find the <a href="https://www.bewise.in/best-arts-classes-near-me" rel="noreferrer noopener" target="_blank">best art classes near me</a>&nbsp;</p>
`;
        this.setState({afterschoolSEOContent:html});
        
    }   

 if(this.props.match.params.subcategory2=='yoga'){

let html=`<p>Searching for best yoga classes near me or Best Yoga trainer near me&nbsp;</p>

<p>Choose the best yoga trainer or yoga classes online/offline&nbsp;</p>

<p>Do you want to join best yoga classes near me in Bangalore?&nbsp;</p>

<p>Join best yoga classes in Bangalore&nbsp;</p>

<p>Practicing yoga daily generates many benefits for both physical and mental health. It helps to lower down your stress levels, and you will feel joyful.  BeWise will help you to choose best yoga classes with experienced yoga trainer nearby your location. Search, filter, compare and then choose the list of <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/yoga" rel="noreferrer noopener" target="_blank">best yoga classes in Bangalore</a>. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}


if(this.props.match.params.subcategory2=='abacus'){

let html=`<p>Searching for best Abacus classes near me for your child?&nbsp;</p>

<p>Choose the best Abacus classes online/offline in Bangalore&nbsp;</p>

<p>Children can start learning abacus at any age between 4-13 years old. Abacus course teaches children to become skilled in rapid mental mathematics with the help of Abacus beads where children use hands to manipulate beads initially. Here in BeWise we have listed the <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/abacus" rel="noreferrer noopener" target="_blank">best Abacus classes in Bangalore</a> for your child mental mathematical development. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps. So hurry up!&nbsp;&nbsp;</p>

<p>Join now the best abacus classes near me.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}


if(this.props.match.params.subcategory2=='kumon'){
 
let html=`<p>Looking for best Kumon classes near me for your child?&nbsp;</p>

<p>Choose the best Kumon classes online/offline in Bangalore&nbsp;</p>

<p>Join now the best Kumon classes near me&nbsp;</p>

<p>&quot;Kumon is a time-tested and parent approved self-enrichment Maths programme. The main aim of Kumon methodology is to advance beyond school grade level at an early age. With the help of Kumon Maths worksheets, children develop mental calculation as well as reasoning skills and grasp the problem solving techniques which helps them in topics like fraction, algebra, trigonometry etc.&nbsp; Check out the list of <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/kumon" rel="noreferrer noopener" target="_blank">best Kumon classes</a> and their fees structure in Bangalore. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}

if(this.props.match.params.subcategory2=='vedic-math'){

let html=`<p>Looking for Vedic Maths Training classes near me?&nbsp;</p>

<p>Choose the best Vedic Maths classes online/offline in Bangalore&nbsp;</p>

<p>Join now the best Vedic Maths classes near me&nbsp;</p>

<p>Vedic Mathematics is a book written by the Indian monk <a href="https://en.wikipedia.org/wiki/Bharati_Krishna_Tirtha" rel="noreferrer noopener" target="_blank">Bharati Krishna Tirtha</a>, and first published in 1965. It contains a list of mathematical techniques. Vedic Maths helps in building speed and accuracy in calculations which are based on addition, subtraction, multiplication, division, squares, roots, and higher calculations. Hence the students of Vedic Maths can easily apply the Vedic Sutras in algebra. In BeWise we have listed many <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/vedic-math" rel="noreferrer noopener" target="_blank">best Vedic maths classes in Bangalore</a>. Check out the list of Vedic maths classes fees near me. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps.&nbsp;</p>

<p>Join now the best Vedic classes near me.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}

if(this.props.match.params.subcategory2=='balvihar'){

let html=`<p>Searching for BalVihar institutes near me?&nbsp;</p>

<p>Choose the best BalVihar in Bangalore&nbsp;</p>

<p>BalVihar is a group of kids, meeting once or twice in a week, at any specific place for the sole purpose of learning our precious culture, spiritual wisdom and related values through stories, games, quizzes, crafts, bhajans, hymns, shlokas, skits, dance etc. Sign up now and find the <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/balvihar" rel="noreferrer noopener" target="_blank">best BalVihar classes in Bangalore</a>. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}

if(this.props.match.params.subcategory2=='shloka-classes'){

let html=`<p>Looking for Shloka classes near me?&nbsp;</p>

<p>Choose the best Shloka classes in Bengaluru&nbsp;</p>

<p>The word shloka means &#39;song&#39;, and originates from the root śru or &#39;hear&#39;. A shloka is generally a couplet of Sanskrit verse, especially one in which each line contains sixteen syllables. Shlokas, which are repeated to aid concentration in meditation, have its origins from the Vedic period. Regularly chanting Shlokas helps children by lowering their blood pressure and heart rate leading them to stay stress-free and healthy. It regulates and gives a boost to your child&#39;s blood circulation and helps in getting rid of the harmful toxins present in the body. Check out the list of <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/shloka-classes" rel="noreferrer noopener" target="_blank">Best Shloka chanting classes in Bangalore</a>. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}

if(this.props.match.params.subcategory2=='coding'){

let html=`<p>Signup for best coding classes near me in Bengaluru&nbsp;</p>

<p>Learn coding and programming in Bangalore| Learn coding from experienced trainer and institutes in Bangalore.&nbsp;</p>

<p>Check out our best coding classes in Bangalore&nbsp;</p>

<p>Due to living in an increasingly digitalized world, computer coding is becoming an important career option for kid&rsquo;s future. These transferrable skills enable kids to learn relevant and competitive skills whilst developing a problem-solving mind-set from an early age. Develop and improve your child skills in coding and computer programing with best private tutors from BeWise. Check out the list of <a href="https://www.bewise.in/bengaluru/after-school-activity/mind-and-skill-enrichment/coding" rel="noreferrer noopener" target="_blank">best Coding classes</a> fees near me in Bangalore. Did you try the latest filter feature at BeWise, wherein you will find the <a href="https://www.bewise.in/best-skill-enrichment-classes-near-me" rel="noreferrer noopener" target="_blank">Best Top Skill Enrichment Classes Near Me</a> at 3 simple steps.&nbsp;</p>`;

  this.setState({afterschoolSEOContent:html});
}


  }


  componentDidMount() {

    // localStorage.setItem('second_sub', '');
    // localStorage.setItem('second_sub_id', '');
    this.setState({
      city: this.props.match.params.city,
      subcategory: this.props.match.params.subcategory,
      subcategory2: this.props.match.params.subcategory2
    });

    this.getPreSchoolCateList();
    //this.renderCate(this.props.match.params.cate);
    this.getPreSchoolList();
    this.setSeoContent();
    /* SEO */
    var var_metatitle = "BeWise";
    var var_metadesc = 'Find, compare and make decisions on Bharatnatyam training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    if (this.props.match.params.subcategory2 == 'bharatnatyam') {
      var_metatitle = "Bharatnatyam Classical Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Bharatnatyam training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'kuchipudi') {
      var_metatitle = "Kuchipudi Classical Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Kuchipudi Classical Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'odissi') {
      var_metatitle = "Odissi Classical Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Odissi Classical Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'kathak') {
      var_metatitle = "Kathak Classical Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Kathak Classical Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'bollywood') {
      var_metatitle = "Bollywood Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Bollywood Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'salsa-and-similar-dance') {
      var_metatitle = "Salsa Western Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Salsa Western Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }


    if (this.props.match.params.subcategory2 == 'hip-hop') {
      var_metatitle = "Hip Hop Western Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Hip Hop Western Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'other-dance-forms') {
      var_metatitle = "Dance Academy, Studio, Performing Arts Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Dance Academy, Studio, Performing Arts  training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'theatre') {
      var_metatitle = "Theatre, Drama Acting Training/Classes/Clubs Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Theatre, Drama Acting training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }


    if (this.props.match.params.subcategory2 == 'ballet') {
      var_metatitle = "Ballet Western Dance Classes/Teachers Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Ballet Western Dance training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }


    if (this.props.match.params.subcategory2 == 'vocal') {
      var_metatitle = "Vocal, Singing, Music Training Institutes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Vocal, Singing, Music training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'instrumental') {
      var_metatitle = "Instrumental, Music Instruments Training Classes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Instrumental, Music Instruments training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'drawing-painting') {
      var_metatitle = "Drawing, Painting, Fine Arts Classes For Kids Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Drawing, Painting, Fine Arts training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'pottery') {
      var_metatitle = "Pottery Classes, Pottery Making For Kids Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Pottery training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'arts-crafts') {
      var_metatitle = "Arts, Crafts, Classes For Kids Bengaluru | BeWise";
      var_metadesc = 'Find, compare and make decisions on Arts, Crafts training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory2 == 'football') {
      var_metatitle = "Football Training Academies/Coaches Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Football training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'tennis') {
      var_metatitle = "Tennis Club/Academies/Coaches Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Tennis training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';
    }

    if (this.props.match.params.subcategory2 == 'cricket') {
      var_metatitle = "Cricket Club/Academies/Coaches Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Cricket training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'swimming') {
      var_metatitle = "Swimming Classes/Instructors Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Swimming training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'hockey') {
      var_metatitle = "Hockey Academies/Coaches/Club Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Hockey training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'badminton') {
      var_metatitle = "Badminton Coaching Classes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Badminton training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'gymnastics') {
      var_metatitle = "Gymnastics Training Center/Classes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Gymnastics training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'athletics-running') {
      var_metatitle = "Athletics, Running Training/Coaching Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Athletics, Running training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'boxing-wrestling') {
      var_metatitle = "Boxing, Wrestling Training Classes/Coaches Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Boxing, Wrestling training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'martial-arts') {
      var_metatitle = "Martial Arts Classes/Instructors Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Martial Arts training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'trekking-rock-climbing') {
      var_metatitle = "Trekking & Rock Climbing Training Camps Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Trekking & Rock Climbing training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'all-others') {
      var_metatitle = "Horse Riding, Kabbadi Training Classes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Horse Riding, Kabbadi training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'chess') {
      var_metatitle = "Chess Training, Coaching Institutes Center Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Chess training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'basketball') {
      var_metatitle = "Basketball Training Academies/Coaches Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Basketball training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'golf') {
      var_metatitle = "Golf Coaching, Training, Clubs, Classes, Centers Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Golf training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'archery') {
      var_metatitle = "Archery Coaching Classes Training Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Archery training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'go-karting') {
      var_metatitle = "Go Karting Training Classes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Go Karting training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'skating') {
      var_metatitle = "Skating Training Classes Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Skating training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }

    if (this.props.match.params.subcategory2 == 'table-tennis') {
      var_metatitle = "Table Tennis Club/Academies/Coaches Bengaluru - Fees & Reviews | BeWise";
      var_metadesc = 'Find, compare and make decisions on Table Tennis training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';

    }


    //var var_metadesc = 'Find, compare and make decisions on  '+this.state.active_cate+' training academies, coaches near your home, for kids, across fees, facilities, reviews and other key information at BeWise, a fun and learning experience to help your child learn and grow';
    this.setState({ metatitle: var_metatitle, metadesc: var_metadesc });


    if (this.state.sub_categories == '42' || this.state.sub_categories == '57'
      || this.state.sub_categories == '58') {
      this.Sub_Cat_type(this.state.sub_categories);
    }
    // this.Sub_Cat_type(57);
    console.log('Latitude')
    var This = this;
    navigator.geolocation.getCurrentPosition(function (position) {
      This.get_current_loaction(position.coords.latitude, position.coords.longitude);
    },
      function (error) {
        console.error("Error Code = ", error);
      });
    this.updateStyleOfFee();
    let data_auth = (localStorage.getItem("myData"));
    let userid;
    if (data_auth) {
      let auth_data = JSON.parse(data_auth)
      this.setState({
        user_id: auth_data.user_id,
      });
    }
  }

  async getfacilities() {
    let response = await FetchCall.getSchoolListDatas('facilities');
    console.log(response);
    if (response) {
      this.setState({ facilitesList: response.results });
    }
  }

  async getschool_type() {
    let response = await FetchCall.getSchoolListDatas('tution_type');
    console.log(response);
    if (response) {
      this.setState({ schooltypeList: response.results });
    }
  }
  async getClassFre() {
    let response = await FetchCall.getSchoolListDatas('class_frequency');
    console.log(response);
    if (response) {
      this.setState({ classificationList: response.results });
    }
  }

  async Sub_Cat_type(id) {
    let response = await FetchCall.getSubCategory(id);
    if (response.status == 1) {
      this.setState({ categorySubTypeList: response.results, cat_type: true, cat_type1: false, cat_type2: false });
    } else {
      this.setState({ cat_type: false });
    }
  }



  handle_Distance = (e) => {
    if (this.state.distance_option === false) {
      this.setState({
        dis_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        dis_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      distance_option: !prevState.distance_option,
    }));

    this.setState({
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: false,
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();

  };
  handle_ptype = (e) => {
    if (this.state.ptype_option === false) {
      this.setState({
        ptype_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        ptype_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      ptype_option: !prevState.ptype_option,
    }));

    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: false,
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      dis_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
  };


  handle_Facilities = (e) => {
    if (this.state.facilities_option === false) {
      this.setState({
        fac_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        fac_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      facilities_option: !prevState.facilities_option,
    }));

    this.setState({
      distance_option: false,
      fees_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };
  handle_Fees = (e) => {
    if (this.state.fees_option === false) {
      this.setState({
        fee_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        fee_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      fees_option: !prevState.fees_option,
    }));

    this.setState({
      distance_option: false,
      facilities_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Review = (e) => {
    if (this.state.review_option === false) {
      this.setState({
        review_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        review_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      review_option: !prevState.review_option,
    }));

    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      reviews_arrow: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Reviews = (e) => {
    if (this.state.reviews_option === false) {
      this.setState({
        reviews_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        reviews_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      reviews_option: !prevState.reviews_option,
    }));
    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Classification = (e) => {
    if (this.state.classification_option === false) {
      this.setState({
        class_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        class_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      classification_option: !prevState.classification_option,
    }));

    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_arrow: false,
      learning_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_learning = (e) => {
    if (this.state.learning_option === false) {
      this.setState({
        learn_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        learn_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      learning_option: !prevState.learning_option,
    }));

    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      curriculam_option: false,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_Curriculam = (e) => {
    if (this.state.curriculam_option === false) {
      this.setState({
        curriculam_arrow: 'fa-angle-up'
      });
    } else {
      this.setState({
        curriculam_arrow: 'fa-angle-down'
      });
    }
    this.setState((prevState) => ({
      curriculam_option: !prevState.curriculam_option,
    }));

    this.setState({
      distance_option: false,
      facilities_option: false,
      fees_option: false,
      review_option: false,
      reviews_arrow: false,
      classification_option: false,
      learning_option: false,
      curriculam_option: true,
      dis_arrow: 'fa-angle-down',
      fac_arrow: 'fa-angle-down',
      fee_arrow: 'fa-angle-down',
      review_arrow: 'fa-angle-down',
      reviews_arrow: 'fa-angle-down',
      class_arrow: 'fa-angle-down',
      learn_arrow: 'fa-angle-down',
      curriculam_arrow: 'fa-angle-down'
    });
    this.updateStyleOfFee();
  };

  handle_clearFilter = (e) => {
    window.location.reload();
  }



  onStarClick = (e) => {
    let probName = e.target.value;
    let reviewData;
    if (this.state.annual_fee_change != false && this.state.feeList != '') {
      reviewData = this.state.feeList.filter(o => o.rating >= probName);
    } else if (this.state.annual_fee_change == false && this.state.feeList == '' && this.state.distance_change != false && this.state.distList != '') {
      reviewData = this.state.distList.filter(o => o.rating >= probName);
    } else if (this.state.annual_fee_change == false && this.state.distance_change == false) {
      reviewData = this.state.schoolsList.filter(o => o.rating >= probName);
    } else {
      reviewData = [];
    }

    this.setState({ filteredList: reviewData, review: e.target.value, reviewList: reviewData, review_change: true });
    this.updateStyleOfFee();
  }



  handleplaceChange = address => {
    this.setState({ address, pin_code: '', state: '', location: '' });
    if (!address)
      this.handleFilterChangeV1(this.state.distance, this.state.annual_fee,
        this.state.review, this.state.classification, this.state.affilation,
        this.state.sub_categories, this.state.curriculam, this.state.sortby,
        this.state.sort_order, this.state.review_social, this.state.partner_type, 1, this.state.operators = '',
        CENTERLAT, CENTERLNG, this.state.perpage);

  };


  handleplaceSelect = address => {
    this.setState({ address: address, location_texts: address });
    sessionStorage.setItem('location_texts', address);
    // this.Geocode_location();
    Geocode.fromAddress(address).then(
      response => {

        var geolen = response.results[0].address_components.length;
        var pincode = '';
        var state = '';
        var city = '';
        for (let i = 0; i < geolen; i++) {

          if (response.results[0].address_components[i].types[0] == "postal_code") {
            pincode = response.results[0].address_components[i].short_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_1") {
            state = response.results[0].address_components[i].long_name;
          }
          if (response.results[0].address_components[i].types[0] == "administrative_area_level_2") {
            city = response.results[0].address_components[i].long_name;
          }

        }

        this.setState({ lat: response.results[0].geometry.location.lat, lng: response.results[0].geometry.location.lng });
        this.handleFilterChangeV1(this.state.distance, this.state.annual_fee,
          this.state.review, this.state.classification, this.state.affilation,
          this.state.sub_categories, this.state.curriculam, this.state.sortby,
          this.state.sort_order, this.state.review_social, this.state.partner_type, 1, this.state.operators = '',
          response.results[0].geometry.location.lat, response.results[0].geometry.location.lng, this.state.perpage);

      },
      error => {
        console.error(error);
      }
    );
  };

  getPreSchoolCateList = async () => {

    let SlugName = JSON.stringify({
      category_slug: this.props.match.params.subcategory
    });

    getSchoolCategoryIdBySlug(SlugName).then((response) => {
      if (response.status == 1) {
        this.setState({
          category_type: response.category_name,
          sub_categories: response.subcategory_id,
          active_cate: response.category_name,
          cate_desc: response.descrp,
        });


        let catData = JSON.stringify({
          id: response.subcategory_id,
        });

        catgoryList(catData).then((response) => {
          if (response.status == 1) {
            const list = response.data;
            let subcate = list.filter(o => o.category_id == this.props.match.params.sub);
            //console.log('subcate', subcate[0].category_name);
            this.setState({
              catelist: list,
              // active_cate: subcate[0].category_name,
            });
          } else {

          }
        });
      }
    });

  };

  getPreSchoolList = async () => {

    let distance = sessionStorage.getItem('distance');
    let current_lats = sessionStorage.getItem('current_lats');
    let current_lngs = sessionStorage.getItem('current_lngs');

    let SlugName = JSON.stringify({
      category_slug: this.props.match.params.subcategory2
    });

    getSchoolCategoryIdBySlug(SlugName).then((response) => {
      if (response.status == 1) {
        this.setState({ subcategory_id: response.subcategory_id, current_category: response.category_name });

        let filterData = JSON.stringify({
          current_latitude: (current_lats != '' && current_lats != null) ? current_lats : this.state.lat,
          current_longitude: (current_lngs != '' && current_lngs != null) ? current_lngs : this.state.lng,
          distance: (distance != '' && distance != null) ? distance : this.state.distance,
          //current_latitude: this.state.lat,
          //current_longitude: this.state.lng,
          //distance: this.state.distance,
          annual_fee: this.state.annual_fee,
          review: 0,
          facilities: this.state.facilities,
          sub_categories: response.subcategory_id,
          location:this.state.current_location,
          review_social: 0,
          page_number: this.state.page_number,
          sub_category_keyword: this.state.current_category,
          perpage: this.state.perpage,
          offset: 0,
          vertical: 'afterschoolactivities'
        });

        verticalTotalCount(filterData).then((response) => {

          this.setState({
            totalrecords: response.data
          });

          let divided = Math.ceil(response.data / this.state.perpage);

          this.setState({
            totalsplitpages: divided
          });


        });

        verticalListing(filterData).then((response) => {
          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              totalPages: 0,
              isloading: false
            });
          }
        });


        /*
        hobbiesSecondSubFilter(filterData).then((response) => {
          if (response.status == 1) {
            const list = response;
            this.setPage(list);
          } else if (response.status == 0) {
            this.setState({
              filteredList: [],
              pageOfItems: [],
              totalPages: 0, isloading: false
            });
          }
        });
        */
      }
    });

  };

  get_current_loaction(latitude, longitude) {
    this.setState({
      current_latitude: latitude,
      current_longitude: longitude,
    });
  }


  showElement = () => {
    this.setState({
      showElements: !this.state.showElements,
    })
  }
  renderCate(param) {
    console.log('param', param)
    let category = '';
    console.log('*** render', this.props.match.params.cate);
    let link = '';
    switch (param) {
      case '26':
        category = 'Sports';
        link = 'sportsInfo';
        break;
      case '27':
        category = 'Music';
        link = 'musicInfo';
        break;
      case '28':
        category = 'Performing arts';
        link = 'danceInfo';
        break;
      case '29':
        category = 'Creative Arts';
        link = 'drawingInfo';
        break;
      case '31':
        category = 'Academic enrichment';
        link = 'mathInfo';
        break;
      case '32':
        category = 'Cultural Learning';
        link = 'cultureInfo';
        break;
      default:
        category = 0;
        break;
    }
    this.setState({
      category_type: category,
      view_page_link: link
    })
  }

  onChangePage = (page_number) => {
    this.setState({
      page_number: page_number,
      currentpage: page_number
    })
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, this.state.sub_categories, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type, page_number);
  }

  homeLink = () => {
    window.location.replace('/');
  }
  subLink = () => {
    window.location.replace('/schoolactivitylinks');
    localStorage.setItem('hob_main_link', this.state.category_type);
    localStorage.setItem('hob_main_link_id', this.props.match.params.cate);
  }

  breadLinkHome = () => {
    window.location.replace('/' + this.state.city + '/' + 'after-school-activity' + '/' + 'sports');
  }

  breadLinkHome2 = () => {
    window.location.replace('/' + this.state.city + '/' + 'after-school-activity' + '/' + this.state.subcategory);
  }

  sub_cate() {
    localStorage.setItem('sub_type', this.state.active_cate);
    localStorage.setItem('hobsub_main_link', this.state.active_cate);
    localStorage.setItem('hobsub_main_link_id', this.state.sub_categories);
    localStorage.setItem('primary_search_path', window.location.href);
  }

  handleCategory(name, id) {
    this.Sub_Cat_type(id);
    this.setState({
      active_cate: name,
      sub_categories: id,
    });
    console.log(this.state.active_cate);
    this.handleFilterChangeV1(this.state.distance, this.state.annual_fee, this.state.review, this.state.classification, this.state.affilation, id, this.state.curriculam, this.state.sortby, this.state.sort_order, this.state.review_social, this.state.partner_type, 1);
  }


  handleSubCategory = (subcategoryname) => {
    window.location.replace('/' + this.state.city + '/after-school-activity/' + this.props.match.params.subcategory + '/' + subcategoryname);
  }

  filterToogle = () => {
    this.setState({
      filter_toggle: !this.state.filter_toggle,
      filter_sort: false
    });
  }
  sortToogle = () => {
    this.setState({
      filter_sort: !this.state.filter_sort,
      filter_toggle: false
    });
  }
  render() {

    const { schoolsList } = this.state;
    let topTrending = {
      category_id: 4,
      city: this.props.match.params.city,
      subcategory: this.state.sub_categories,
      subcategory_term: this.props.match.params.subcategory,
      category_name: 'after-school-activity',
      sub_category: this.props.match.params.subcategory2
    }
    const menuData = {
      category: 'After School Activity',
      category_link: `/${this.state.city}/after-school-activity/sports`,
      subcategory_one: this.state.active_cate,
      subcategory_one_link: `/${this.state.city}/after-school-activity/${this.props.match.params.subcategory}`,
      subcategory_one_desc: '',
      subcategory_two: this.state.current_category,
      subcategory_two_link: ``,
      subcategory_two_desc: '',
      active_main: 'after-school-activity',
      active_submain: this.props.match.params.subcategory,
      active_menu: this.props.match.params.subcategory2
    }


    let filteredData = [];
    //console.log("sdfsd", this.state.curriculam_texts);
    let curriculamdata = sessionStorage.getItem('curriculam_texts').split(',');
    if (sessionStorage.getItem('curriculam_texts') != '')
      filteredData.push('curriculum');

    let locationdata = sessionStorage.getItem('location_texts');
    if (sessionStorage.getItem('location_texts') != '')
      filteredData.push('location');

    let feesdata = sessionStorage.getItem('fees_texts').split(',');
    if (sessionStorage.getItem('fees_texts') != '')
      filteredData.push('fees');

    let ratingsdata = sessionStorage.getItem('ratings_texts').split(',');
    if (sessionStorage.getItem('ratings_texts') != '')
      filteredData.push('ratings');

    let googleratingsdata = sessionStorage.getItem('googleratings_texts').split(',');
    if (sessionStorage.getItem('googleratings_texts') != '')
      filteredData.push('googleratings');

    let affilationdata = sessionStorage.getItem('affilation_texts').split(',');
    if (sessionStorage.getItem('affilation_texts') != '')
      filteredData.push('affilation');

    let classfrequencydata = sessionStorage.getItem('classification_texts').split(',');
    if (sessionStorage.getItem('classification_texts') != '')
      filteredData.push('classfrequency');

    let typedata = sessionStorage.getItem('type_texts').split(',');
    if (sessionStorage.getItem('type_texts') != '')
      filteredData.push('type');

    let pageinfo = {
      fromvertical: this.props.match.params.subcategory,
      parent: this.props.match.params.subcategory +' centres'
    }



    let catename = (this.props.match.params.subcategory2=='singing-classes') ? "Vocal": this.props.match.params.subcategory2;

    const pagetitle = '<h1>Best '+catename+' Academies ('+this.state.active_cate+') in ' +this.props.match.params.city+' : 2024-25</h1>'
    
    return (
      <React.Fragment>
        {this.state.isloading === true &&
          (
            <React.Fragment>
              <div class="overlay-custom"></div>
              <div class='spinner' role='status'>
                <span class='sr-only'>Loading...</span>
              </div>
            </React.Fragment>
          )}

       

        <Header menu_data={menuData} login={this.state.openModalLogin}
          onMobileFilterCall={this.filterToogle} onMobileSortCall={this.sortToogle} />
        <span id='Popover-mobile-filter'></span>
        <span id='Popover-mobile-sort'></span>
        <Popover className='filter-pop-over' hideArrow={true}
          placement="bottom" isOpen={this.state.filter_toggle} target="Popover-mobile-filter">
          <PopoverHeader>Sharpen your search <span class='popupclose' onClick={this.filterToogle}>close</span></PopoverHeader>
          <PopoverBody>
            {this.filterFunction(1)}
          </PopoverBody>
        </Popover>
        <Popover className='filter-pop-over' hideArrow={true}
          placement="bottom" isOpen={this.state.filter_sort} target="Popover-mobile-sort">
          <PopoverHeader>
            Sort
            <span class='popupclose' onClick={this.sortToogle}>close</span>
          </PopoverHeader>
          <PopoverBody>
            <div className='container'>
              {this.state.sortby && (
                <div className='row scrollmenu new-sort-option'>
                  <div className='col-12'>
                    <a
                      className={this.state.sortby_option ? 'filter-menu active' : 'filter-menu'}
                      href='javascript:;' onClick={this.handle_Sortby} >
                      Ascending
                    </a>
                    &nbsp;|&nbsp;
                    <a className={!this.state.sortby_option ? 'filter-menu active' : 'filter-menu'}
                      href='javascript:;' onClick={this.handle_Sortby}>
                      Descending
                    </a>
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='col-12'>
                  <ul className='pop-sort'>
                    <li
                      onClick={() => this.handle_sortby_list(null, '')}
                      className={this.state.sortby == '' && 'active'}>Default Sort </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 1)}
                      className={this.state.sortby == 1 && 'active'}>Name </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 2)}
                      className={this.state.sortby == 2 && 'active'}>Location </li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 3)}
                      className={this.state.sortby == 3 && 'active'}>Rating</li>
                    <li
                      onClick={() => this.handle_sortby_list(null, 4)}
                      className={this.state.sortby == 4 && 'active'}>Fees</li>
                  </ul>
                </div>
              </div>
            </div>
          </PopoverBody>
        </Popover>
        <section class="secound-landing features-area nav nav-tabs links-page new-landing-page" id="nav-tab" role="tablist">
          <div className='container'>
            <div class="row" style={{ padding: 10 }}>
              {filteredData.length > 0 && (
                <div className="col-12 mb-3 d-block d-md-none">
                  <div className='row new-sort mob-sort-sec ml-0'>
                    <div className={'col-4 text-center'}>
                      {filteredData.length > 0 && (
                        <span class="clearallfilters" onClick={e => this.removeAllCache()}>Clear All</span>
                      )}
                    </div>
                    <div className='col-md-12 pl-2 pr-2'>
                      <div class="filterations">
                        <div class="filtersection">

                          <ul class="tagblock">

                            {filteredData.includes("curriculum") && (
                              <li class="tags">Curriculum Type:
                                <ul class="tagsList">
                                  {curriculamdata.length > 0 && curriculamdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagC(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("location") && (
                              <li class="tags">Location:
                                <ul class="tagsList">
                                  {locationdata != '' && (<li>{locationdata}<a onClick={e => this.onRemoveTagL(locationdata, e)}>x</a></li>)

                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("fees") && (
                              <li class="tags">Fees:
                                <ul class="tagsList">
                                  {feesdata.length > 0 && feesdata.map((item, i) => {
                                    return (<li>{'₹' + Number(item).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}<a onClick={e => this.onRemoveTagFees(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("ratings") && (
                              <li class="tags">Ratings:
                                <ul class="tagsList">
                                  {ratingsdata.length > 0 && ratingsdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagR(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}


                            {filteredData.includes("googleratings") && (
                              <li class="tags">Google Rating:
                                <ul class="tagsList">
                                  {googleratingsdata.length > 0 && googleratingsdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagGR(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("affilation") && (
                              <li class="tags">Learning Location:
                                <ul class="tagsList">
                                  {affilationdata.length > 0 && affilationdata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagAF(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("classfrequency") && (
                              <li class="tags">Class Frequency:
                                <ul class="tagsList">
                                  {classfrequencydata.length > 0 && classfrequencydata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagCF(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                            {filteredData.includes("type") && (
                              <li class="tags">Type:
                                <ul class="tagsList">
                                  {typedata.length > 0 && typedata.map((item, i) => {
                                    return (<li>{item}<a onClick={e => this.onRemoveTagT(i, item, e)}>x</a></li>)

                                  })
                                  }
                                </ul>
                              </li>
                            )}

                          </ul>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="mt-3 col-lg-3 col-md-4 pl-md-0 d-none d-md-block">
                <div className='laning-stick'>
                  <div className="left-side-box d-none d-md-block">
                    <div className="left-head mob-col-wrap" data-title="Search Filters" data-intro="Use filters for best results">
                    Use Below Filters for Best Results &nbsp; <img src="/assets/icons/animatedarrow.gif" class="arrowanimated" />
                      <button className="btn mob-collapse-btn pr-0 d-block d-md-none">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                      </button>
                    </div>
                    {this.filterFunction(2)}
                    <div className="d-none d-md-block">
                      
                    <LeadSmall pageinfo={pageinfo} param={topTrending}/>
                    <TopTrending param={topTrending} />
                    <ArticleSmall pageinfo={pageinfo} param={topTrending}/>

                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-3 col-lg-8 col-md-8">
                <div className="col-12 px-0 d-none d-md-block">

                <div class="topfilterflexbar">
                        <div class="flx_breadcrum">
                          <span className='mb4c'>
                              <b style={{ 'cursor': 'pointer' }} onClick={() => this.homeLink()}>Home&nbsp;<i class="fa fa-angle-right"></i>&nbsp;</b>
                              <b style={{ 'cursor': 'pointer' }} onClick={() => this.breadLinkHome()}>After School Activity&nbsp;<i class="fa fa-angle-right"></i>&nbsp;</b>
                              <b style={{ 'cursor': 'pointer' }} onClick={() => this.breadLinkHome2()}>{this.state.active_cate}&nbsp;<i class="fa fa-angle-right"></i>&nbsp;</b>
                              <b><span style={{ textTransform: 'capitalize' }}>{this.state.current_category}</span></b>
                          </span>
                        </div>
                        
                        <div class="flx_sortby">
                        <div class="flx_soryby_inner">
                        <div className={this.state.sortby ? 'disflex' : 'disflex'}>
                            <div>Sort By</div><select className='form-control special landing-sort-drop selectpicker' name="sortby" value={this.state.sortby} onChange={this.handle_sortby_list}>
                            <option value="">Default Sort</option>
                            <option value="1">Name </option>
                            <option value="2">Location </option>
                            <option value="3">Rating</option>
                            <option value="4">Fee</option>
                          </select>
                        </div>
                        {this.state.sortby &&
                          (
                            <div className='col-md-1 p-0'>
                              <span className="tile-sort-icon" onClick={this.handle_Sortby}>
                                {(this.state.sortby_option == true) ?
                                  (<i class="fas fa-sort-amount-up" aria-hidden="true"></i>) :
                                  (<i class="fas fa-sort-amount-down" aria-hidden="true"></i>
                                  )}
                              </span>
                            </div>
                          )
                        }
                        <div className={this.state.sortby ? 'disflex' : 'disflex'}>
                        <div>Entries</div> <select className='form-control selectpicker special landing-sort-drop'
                            name="perpage" value={this.state.perpage} onChange={this.handlePerPage}>
                            <option value="15">15</option>
                            <option value="30">30 </option>
                            <option value="50">50</option>
                          </select>
                        </div>
                        </div>

                        </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">

                <div class="row pageTitleH1" dangerouslySetInnerHTML={{__html:pagetitle}} /> 
                
                  {this.paginationHtml()}
                  <div className='row pb-16'>
                    {this.state.filteredList.length === 0 && this.state.isloading === false && (
                      <p>Currently data doesn't exist, please get in touch if needed <br/>
                      We're currently gathering and uploading information @ {this.state.current_location}. <br/>
                      Please check back in a few weeks. We apologize for any inconvenience</p>
                    )}
                    <AllVerticalSte1 pageinfo={pageinfo} />   
                     
                    {this.state.isloading === true &&

                      <CardSkeleton cards={15} />
                    }

                    {this.renderNewTile()}
                  </div>
                  <div className='mb-3'>
                    {this.paginationHtml()}
                  </div>
                  <div className="d-block d-md-none">
                    <TopTrending param={topTrending} />
                  </div>
                </div>
              </div>
              <div className="mt-3 col-md-1 pl-md-2 m-hide-ads">
                <div className='laning-stick'>
                  <AfterSchoolRight />
                </div>
              </div>
            </div>
            <AdsHorizandal />

            <div class="row desktoponly">
              <div class="col-lg-12 ">
                <div class="specialcontent" dangerouslySetInnerHTML={{ __html: this.state.afterschoolSEOContent}}></div>
              </div>
            </div>
            <div class="row mobileonly">
              <div class="col-lg-12 ">
                <div class="specialcontent" dangerouslySetInnerHTML={{ __html: this.state.afterschoolSEOContent}}></div>
              </div>
            </div>

          </div>
        </section>


        <Modal isOpen={this.state.showcp} centered size='lg'>

<ModalBody>
  <h4 class='csph4'>Contact {this.state.orgName}</h4>
  <button
    className='close-btn'
    data-dismiss='modal'
    aria-label='Close'
    onClick={this.handleCloseCp}
  >
    <img src={closebtn} alt='close' />
  </button>
  <div class="formbox csp">
    <form
      method='post'
      onSubmit={this.handleSubmitEnquiry}
      autoComplete='off'
      id='loginForm'
    >
      <div
        className='form-group has-feedback'
        style={{ width: '55%', float: 'left' }}
      >
        <label className='n7tr' >
          First Name
        </label>
        <input
          type='text'
          name='first_name'
          className='form-control' onChange={this.handleChange} required
        />

      </div>
      <div
        className='form-group has-feedback'
        style={{ width: '40%', float: 'right' }}
      >
        <label className='n7tr' >
          Last Name
        </label>
        <input
          type='text'
          name='last_name'
          className='form-control'  onChange={this.handleChange}  required
        />

      </div>
      <div className='form-group has-feedback'>
        <label className='n7tr'>
          Mobile Number
        </label>
        <input
          type='text'
          name='reg_mobile'
          className='form-control'  onChange={this.handleChange}  required
        />

      </div>
      <div className='form-group has-feedback'>
        <label className='n7tr'>
          Email ID
        </label>
        <input
          type='text'
          name='reg_email'
          className='form-control'  onChange={this.handleChange}  value={this.state.email_id} required
        />

      </div>

      <div className='form-group has-feedback'>
        <label className='n7tr'>
          Any Message
        </label>
        <textarea

          name='any_message'
          value={this.state.any_message}  onChange={this.handleChange} 

          className='form-control' required
        />
      </div>

      <div className='form-group has-feedback'>
        <input
          type='submit'
          name='submit'
          value='Submit'
          className='submit btn btn-primary btn-block btn-css'
        />
      </div>
    </form>
  </div>
</ModalBody>

</Modal>

        <Footer />
      </React.Fragment>
    );
  }
  renderNewTile() {
    return this.state.pageOfItems.map((item, index) => {
      if(index==7){
        return (
          
            <AdsDynamicMobileMiddle />
           
        )
      }
      return (
        <React.Fragment>
          {SCREEN_SIZE < 768 ?
            <Link className='tile-link' to={'/' + this.state.city + '/after-school-activity/' + this.state.subcategory + '/' + this.state.subcategory2 + '/' + item.path_term} onClick={() => this.sub_cate()}>
              {this.getContentMobile(item)}
            </Link>
            :
            this.getContent(item)
          }

        </React.Fragment>
      );
    });
  }
  addTowishList = async (e, data) => {
    e.preventDefault();
    let logged_auth = this.state.logged_auth;
    if (logged_auth == 'true') {
      await addToWishList(data);
    } else {
      this.setState({
        openModalLogin: true
      })
    }
  }

  addToCompare = async (e, data) => {
    e.preventDefault();
    let logged_auth = this.state.logged_auth;
    if (logged_auth == 'true') {
      await addToCompareList(data);
    } else {
      this.setState({
        openModalLogin: true
      })
    }
  }

  getContentMobile = (item) => {
    let fee = item.avg_fee != 0 ? '₹' + Number(item.avg_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? 'hidden' : '';
    let isDesk = SCREEN_SIZE > 767 ? 'hidden' : '';
    let wishlist = {
      category_id: 4,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href
    }
    let compare = {
      id: item._id,
      type: 'hobby',
      keyword: 'hobby_compare'
    }

    let stamped ='';
    if(item.stamp_img){
      stamped='premiumuser ';
    }

    let orgphoto = '';
    let orgphotos = (item.photos!='') ? item.photos.split(","):[];

    if(orgphotos.length==0){
        orgphoto = '/assets/images/school-default.png';
    }else{
        orgphoto = AZ_ASSET_PATH+orgphotos[0];
    }


    let regonly = 0;
    let regonlyorpaidalso = 0;

    if(item.vendor_id>1 && stamped!=''){
        regonlyorpaidalso = 1;
    }
    else{
      regonlyorpaidalso = 0;
    }

    if(item.vendor_id>1 && stamped==''){
      regonly = 1;
    }
    else{
      regonly=0;
    }
    
    return (
      <div className={stamped + ' tilerow mobileview'}>
      <div className='newtile'>
          <div className='rowflex'>
      
            <div className='orgbg' style={{backgroundImage:`url(`+orgphoto+`)`}} >
              { item.stamp_img!='' &&
                <div className='tile-stamp-sec col-12'>
                  <img className='tile-stamp-img' src={stampedicon} />
                </div>
              }
            </div>

            <div className='newtile-info'>
              <div className='tile-detail-sec tile-title row align-items-center inst_displayflex'>
                <div className='inst_name'>
                  <p className='text-wrap'>{item.organisation_name}</p>
                </div>
                <div className='inst_action_btns displayflex'>
               

                { regonly==1 &&
                  <div className="tile-btn-biew">
                    <button className='btn btn-sm btn-primary' data-name={item.organisation_name} data-id={item.id} onClick={this.enquireThisRegOnly}>Enquire Now</button>
                  </div>
                  }

                  { regonlyorpaidalso==1 &&
                  <div className="tile-btn-biew">
                    <button className='btn btn-sm btn-primary' data-name={item.organisation_name} data-id={item.id} onClick={this.enquireThisPaidOnly}>Enquire Now</button>
                  </div>
                  }
                  <div className='tile-btn-biew pull-right'>
                      <Link target="_blank"  to={'/' + this.state.city + '/after-school-activity/' + this.state.subcategory + '/' + this.state.subcategory2 + '/' + item.path_term} onClick={() => this.sub_cate()}>
                        <button className='btn btn-sm btn-primary'>More Info</button>
                      </Link>
                  </div>
                </div>
              </div>
              <div className='tile-detail-sec tile-adrs row'>
                {this.state.isEschool &&
                  <p className='text-wrap'>E-School</p>
                }
                {!this.state.isEschool &&
                  <p className='text-wrap'>{item.address}</p>
                }
              </div>
              <div className='tile-detail-sec align-items-center row'>
                <div className='col-lg-3 col-xs-6 p-0'>
                  <div className='tile-distance badge badge-secondary'>
                    <p className='text-wrap'>
                      <span><i class="fa fa-map-marker" aria-hidden="true"></i></span>&nbsp;
                      {!this.state.isEschool && <span>{parseFloat(item.distance).toFixed(1)} KM </span>}&nbsp;
                      <span title={item.area_name}>{item.area_name}</span>
                    </p>
                  </div>
                </div>
                <div className='col-lg-3 col-xs-6 p-0 d-flex justify-content-center'>
                  <div className='tile-rate badge badge-secondary'>
                    <p className='text-wrap'>
                      <span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;</span>
                      <span>{item.rating ? item.rating : '0.0'}</span>
                    </p>
                  </div>
                </div>
                <div className='col-lg-3 col-xs-6 p-0'>
                  <div className='tile-compare' onClick={(e) => this.addToCompare(e, compare)}>
                    <img src={compareicon} />&nbsp;Compare
                  </div>
                </div>
                <div className='col-lg-3 col-xs-6 p-0'>
                  <div className='tile-wish' onClick={(e) => this.addTowishList(e, wishlist)}>
                    <img src={actionicon3} />&nbsp; Wishlist
                  </div>
                </div>
              </div>
              <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                <div className='col col-xs-4 p-0'>
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                 

                {(item.current_vacancies!=null && !item.stamp_img) &&
                <div className='col col-xs-3 p-0'>
                  <label>Current Vacancies</label>
                  <p className={item.current_vacancies}>{item.current_vacancies}</p>
                </div>
                }

                {(item.current_vacancies!=null && item.stamp_img) &&
                 <div className='col col-xs-3 p-0'>
                  <label>Current Vacancies</label>
                  <p className="available">Available</p>
                </div>
                }

                <div className='col col-xs-4 p-0'>
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
            </div>
            <div className={`col-12 ${isDesk}`}>
              <div className='tile-detail-sec tile-details row'>
                <div className='col p-0'>
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
               

                 {(item.current_vacancies!=null && !item.stamp_img) &&
                <div className='col p-0'>
                  <label>Current Vacancies</label>
                  <p className={item.current_vacancies}>{item.current_vacancies}</p>
                </div>
                }

                {(item.current_vacancies!=null && item.stamp_img) &&
                 <div className='col p-0'>
                  <label>Current Vacancies</label>
                  <p className="available">Available</p>
                </div>
                }


                <div className='col p-0'>
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
             
          </div>
        </div>
        
        <div className='rowflex'>
              <div className='tile-seo-tag'>
                <div className={`${isMobile} tile-seo-tag-desk`}>
                  {item.keywords.map((data) => {
                    return (<span class="badge badge-defult">{data}</span>)
                  })}
                </div>
                <div className={`${isDesk} tile-seo-tag-mob`}>
                  {item.keywords.map((data) => {
                    return (<span class="badge badge-defult">{data}</span>)
                  })}
                </div>
              </div>
        </div>
      </div>
    </div>
  )
  }  


  getContent = (item) => {
    let fee = item.avg_fee != 0 ? '₹' + Number(item.avg_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? 'hidden' : '';
    let isDesk = SCREEN_SIZE > 767 ? 'hidden' : '';
    let wishlist = {
      category_id: 4,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href
    }
    let compare = {
      id: item._id,
      type: 'hobby',
      keyword: 'hobby_compare'
    }

    let stamped ='';
    if(item.stamp_img){
      stamped='premiumuser ';
    }

    let orgphoto = '';
    let orgphotos = (item.photos!='') ? item.photos.split(","):[];

    if(orgphotos.length==0){
        orgphoto = '/assets/images/school-default.png';
    }else{
        orgphoto = AZ_ASSET_PATH+orgphotos[0];
    }


    let regonly = 0;
    let regonlyorpaidalso = 0;

    if(item.vendor_id>1 && stamped!=''){
        regonlyorpaidalso = 1;
    }
    else{
      regonlyorpaidalso = 0;
    }

    if(item.vendor_id>1 && stamped==''){
      regonly = 1;
    }
    else{
      regonly=0;
    }
    
    return (
      <div className={stamped + ' tilerow '}>
      <div className='newtile'>
          <div className='rowflex'>
            <div className='newtile-img orgimg_desktop' style={{backgroundImage:`url(`+orgphoto+`)`}}>
              &nbsp;
            </div>
            <div className='newtile-info'>
              <div className='tile-detail-sec tile-title row align-items-center inst_displayflex'>
                <div className='inst_name'>
                  <p className='text-wrap'>{item.organisation_name}</p>
                </div>
                <div className='inst_action_btns displayflex'>
                  { stamped!='' &&
                  <div className='stampmoved'>
                   <div class="premiumstamp"><img src="/assets/images/stamp.png" /></div>
                  </div>
                  }


{ regonly==1 &&
  <div className="tile-btn-biew">
    <button className='btn btn-sm btn-primary' data-name={item.organisation_name} data-id={item.id} onClick={this.enquireThisRegOnly}>Enquire Now</button>
  </div>
  }

  { regonlyorpaidalso==1 &&
  <div className="tile-btn-biew">
    <button className='btn btn-sm btn-primary' data-name={item.organisation_name} data-id={item.id} onClick={this.enquireThisPaidOnly}>Enquire Now</button>
  </div>
  }

 

                  <div className='tile-btn-biew pull-right'>
                      <Link target="_blank"  to={'/' + this.state.city + '/after-school-activity/' + this.state.subcategory + '/' + this.state.subcategory2 + '/' + item.path_term} onClick={() => this.sub_cate()}>
                        <button className='btn btn-sm btn-primary'>More Info</button>
                      </Link>
                  </div>
                </div>
              </div>
              <div className='tile-detail-sec tile-adrs row'>
                {this.state.isEschool &&
                  <p className='text-wrap'>E-School</p>
                }
                {!this.state.isEschool &&
                  <p className='text-wrap'>{item.address}</p>
                }
              </div>
              <div className='tile-detail-sec align-items-center row'>
                <div className='col-lg-3 col-xs-6 p-0'>
                  <div className='tile-distance badge badge-secondary'>
                    <p className='text-wrap'>
                      <span><i class="fa fa-map-marker" aria-hidden="true"></i></span>&nbsp;
                      {!this.state.isEschool && <span>{parseFloat(item.distance).toFixed(1)} KM </span>}&nbsp;
                      <span title={item.area_name}>{item.area_name}</span>
                    </p>
                  </div>
                </div>
                <div className='col-lg-3 col-xs-6 p-0 d-flex justify-content-center'>
                  <div className='tile-rate badge badge-secondary'>
                    <p className='text-wrap'>
                      <span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;</span>
                      <span>{item.rating ? item.rating : '0.0'}</span>
                    </p>
                  </div>
                </div>
                <div className='col-lg-3 col-xs-6 p-0'>
                  <div className='tile-compare' onClick={(e) => this.addToCompare(e, compare)}>
                    <img src={compareicon} />&nbsp;Compare
                  </div>
                </div>
                <div className='col-lg-3 col-xs-6 p-0'>
                  <div className='tile-wish' onClick={(e) => this.addTowishList(e, wishlist)}>
                    <img src={actionicon3} />&nbsp; Wishlist
                  </div>
                </div>
              </div>
              <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                <div className='col col-xs-4 p-0'>
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                
                {(item.current_vacancies!=null && !item.stamp_img) &&
                <div className='col col-xs-3 p-0'>
                  <label>Current Vacancies</label>
                  <p className={item.current_vacancies}>{item.current_vacancies}</p>
                </div>
                }

                {(item.current_vacancies!=null && item.stamp_img) &&
                 <div className='col col-xs-3 p-0'>
                  <label>Current Vacancies</label>
                  <p className="available">Available</p>
                </div>
                }

                <div className='col col-xs-4 p-0'>
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
            </div>
            <div className={`col-12 ${isDesk}`}>
              <div className='tile-detail-sec tile-details row'>
                <div className='col p-0'>
                  <label>Category</label>
                  <p>{this.state.active_cate}</p>
                </div>
                

                 {(item.current_vacancies!=null && !item.stamp_img) &&
                <div className='col p-0'>
                  <label>Current Vacancies</label>
                  <p className={item.current_vacancies}>{item.current_vacancies}</p>
                </div>
                }

                {(item.current_vacancies!=null && item.stamp_img) &&
                 <div className='col p-0'>
                  <label>Current Vacancies</label>
                  <p className="available">Available</p>
                </div>
                }


                <div className='col p-0'>
                  <label>Annual Fee (Indicative)</label>
                  <p>{fee}</p>
                </div>
              </div>
             
          </div>
        </div>
        
        <div className='rowflex'>
              <div className='tile-seo-tag'>
                <div className={`${isMobile} tile-seo-tag-desk`}>
                  {item.keywords.map((data) => {
                    return (<span class="badge badge-defult">{data}</span>)
                  })}
                </div>
                <div className={`${isDesk} tile-seo-tag-mob`}>
                  {item.keywords.map((data) => {
                    return (<span class="badge badge-defult">{data}</span>)
                  })}
                </div>
              </div>
        </div>
      </div>
    </div>
  )
  }  

  getContentOld = (item) => {
    let fee = item.avg_fee != 0 ? '₹' + Number(item.avg_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';
    let city = this.props.match.params.city;
    let isMobile = SCREEN_SIZE < 768 ? 'hidden' : '';
    let isDesk = SCREEN_SIZE > 767 ? 'hidden' : '';
    let wishlist = {
      category_id: 4,
      category: this.state.sub_categories,
      id: item._id,
      user_id: this.state.user_id,
      vendor_id: item.vendor_id,
      full_url: window.location.href
    }
    let compare = {
      id: item._id,
      type: 'hobby',
      keyword: 'hobby_compare'
    }

    let stamped ='';
    if(item.stamp_img){
      stamped='premiumuser ';
    }

    let orgphoto = '';
    let orgphotos = (item.photos!='') ? item.photos.split(","):[];

    if(orgphotos.length==0){
        orgphoto = '/assets/images/school-default.png';
    }else{
        orgphoto = AZ_ASSET_PATH+orgphotos[0];
    }

    return (
      <div className='col-xs-12 col-md-12'>
        <div className='row landing-tile'>
          <div className='col-xs-12 col-lg-12'>
            <div className='row align-items-center d-flex'>
              { item.stamp_img!='' &&
                <div className='tile-stamp-sec col-12'>
                  <img className='tile-stamp-img' src={stampedicon} />
                </div>
              }
              <div className='col-3 pr-0 '>
                <div className='tile-img'>
                  <img src={item.images} />
                </div>
              </div>
              <div className='col-9'>
                <div className='tile-detail-sec tile-title row align-items-center'>
                  <div className='col-lg-10 p-0'>
                    <p className='text-wrap'>{item.organisation_name}</p>
                  </div>
                  <div className='col-lg-2 p-0 d-none d-md-block'>
                    <div className='tile-btn-biew pull-right'>
                      <Link target="_blank"  to={'/' + this.state.city + '/after-school-activity/' + this.state.subcategory + '/' + this.state.subcategory2 + '/' + item.path_term} onClick={() => this.sub_cate()}>
                        <button className='btn btn-sm btn-primary'>More Info</button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className='tile-detail-sec tile-adrs row'>
                  <p className='text-wrap'>{item.address}</p>
                </div>
                <div className='tile-detail-sec align-items-center row'>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-distance badge badge-secondary'>
                      <p className='text-wrap'>
                        <span><i class="fa fa-map-marker" aria-hidden="true"></i>&nbsp;</span>
                        <span>{parseFloat(item.distance).toFixed(1)} KM &nbsp;</span>
                        <span title={item.area_name}>{item.area_name}</span>
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-rate badge badge-secondary'>
                      <p className='text-wrap'>
                        <span><i class="fa fa-star" aria-hidden="true"></i>&nbsp;</span>
                        <span>{item.rating ? item.rating : '0.0'}</span>
                      </p>
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-compare' onClick={(e) => this.addToCompare(e, compare)}>
                      <img src={compareicon} />&nbsp;Compare
                    </div>
                  </div>
                  <div className='col-lg-3 col-xs-6 p-0'>
                    <div className='tile-wish' onClick={(e) => this.addTowishList(e, wishlist)}>
                      <img src={actionicon3} />&nbsp; Wishlist
                    </div>
                  </div>
                </div>
                <div className={`tile-detail-sec tile-details row ${isMobile}`}>
                  <div className='col p-0'>
                    <label>Category</label>
                    <p>{this.state.current_category} {item.train_name}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Age Group</label>
                    <p>{item.min_age}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Learning @</label>
                    <p className={item.learnat=='Online'?'onlinecss':''}>{item.learnat}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Free Trail Class</label>
                    <p>{item.free_trail_class==0?'NA':(item.free_trail_class==1)?"Yes":'NA'}</p>
                  </div>
                </div>
              </div>
              <div className={`col-12 ${isDesk}`}>
                <div className='tile-detail-sec tile-details row'>
                  <div className='col p-0'>
                    <label>Category</label>
                    <p>{this.state.current_category} {item.train_name}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Age Group</label>
                    <p>{item.min_age}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Free Trail Class</label>
                    <p>{item.free_trail_class==0?'NA':item.free_trail_class}</p>
                  </div>
                  <div className='col p-0'>
                    <label>Learning @</label>
                    <p>{item.learnat}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-xs-12 col-lg-12'>
            <div className='row align-items-center'>
              <div className='col-lg-12 col-sm-12'>
                <div className='tile-seo-tag'>
                  <div className={`${isMobile} tile-seo-tag-desk`}>
                    {item.keywords.map((data) => {
                      return (<span class="badge badge-defult">{data}</span>)
                    })}
                  </div>
                  <div className={`${isDesk} tile-seo-tag-mob`}>
                    {item.keywords.map((data) => {
                      return (<span class="badge badge-defult">{data}</span>)
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  renderList() {
    return this.state.pageOfItems.map((item) => {
      let fee = item.avg_anual_fee != 0 ? '₹' + Number(item.avg_anual_fee).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 'NA';
      return (
        <div className='col-sm-6 col-md-6 col-xl-4 col-lg-6 hover1' style={{ padding: 10 }} key={item._id}>
          <div
            className='img-school s6g6bd'
            style={{ backgroundImage: `url('${item.images ? item.images : '../assets/icons/1.png'}')` }}
          >
            <div className="conntent-bottom">
              <div className='r5b99d'>
                <span className='g4yb'>{item.organisation_name}</span>
              </div>
              <div className='u0865'>
                <div className='gf5-review'>
                  <div className='n6cd-r'>
                    <img
                      src={BASE_URL + 'assets/icons/review-star.png'}
                      className='star-r'
                      alt='star  '
                    />
                  </div>
                  {<div className='v5dfa'>{item.rating ? item.rating : '0.0'}</div>}
                </div>
                <div className='f5va-label'>
                  <i className='fas fa-map-marker-alt custom'></i>{' '}
                  <span>&nbsp;{parseFloat(item.distance).toFixed(1)} km</span>
                </div>
              </div>
            </div>
          </div>
          <div className='overlay'>
            <div className='text'>
              <div className='row'>
                <div className={item.stamp_img ? 'col-md-9' : 'col-md-12'}>
                  <h6 className='school-n6f'>{item.organisation_name}</h6>
                </div>
                {item.stamp_img &&
                  <div className='col-md-3 stamp-sec'>
                    <img src={IMG_URL + item.stamp_img} />
                  </div>
                }
              </div>
              <p>
                <span className='n7v5'>Place</span> : {item.location}
              </p>
              <p className="capitalize">
                <span className='n7v5'>Type</span> : {item.sub_cat_name}
              </p>
              <p>
                <span className='n7v5'>Avg Fee</span> : {fee == 'NA' ? fee : fee + ' /Month'}
              </p>
              <p>
                <span className='n7v5'>Establishment Year</span> : {item.establishment_Year}</p>
              <Link to={'/' + this.state.city + '/after-school-activity/' + this.state.subcategory + '/' + this.state.subcategory2 + '/' + item.path_term} onClick={() => this.sub_cate()}>
                <button className='btn hover-btn'>View More</button>
              </Link>
            </div>
          </div>
        </div>
      );
    });
  }

  paginationHtml = () => {
    if (this.state.pageOfItems.length > 0)
      return (
        <div className='middlelist row paginations'>
          <div class="col-8 p-0" ><div className="pageof">{this.state.pageindex} of {this.state.totalsplitpages} Pages<span className="totalrecordsinfo">({this.state.totalrecords} total records)</span></div></div>
          <div class="col-4 p-0">
            <div class="pull-right">
              <div className={this.state.pgnumber == 0 ? "previouslist hidden" : "previouslist"} onClick={() => this.onChangePrevPage(this.state.pgnumber)}>
                <div class="vertical-prev">Prev</div>
              </div>
              <div className={this.state.pageindex == this.state.totalsplitpages ? "nextlist hidden" : "nextlist"}  onClick={() => this.onChangeNextPage(this.state.pgnumber)}>
                <div class="vertical-next">Next</div>
              </div>
            </div>
          </div>
        </div>
      )
  }
  filterFunction = (type) => {
    return (
      <div className="left-side-body">
        {(this.state.cat_type === true) ?
          <React.Fragment>
            <div className='f-b6fd'>
              <div className='n8ds-head'>
                <p> Type</p>
              </div>
              <div
                className={'arrow-head fa ' + this.state.curriculam_arrow}
                onClick={this.handle_Curriculam}
              ></div>
            </div>

            <div className='filter-a1'>
              {this.state.curriculam_option === true ? (
                <ul className='f-li-none'>
                  {this.state.categorySubTypeList.length > 0 &&
                    this.state.categorySubTypeList.map((item, i) => {
                      return (
                        <li>
                          {' '}
                          <input
                            type='checkbox'
                            onChange={this.handleCurriculamCheckbox}
                            name='curriculam'
                            datatext={item.category_name}
                            value={item.category_id}
                          />{' '}
                          {item.category_name}
                        </li>
                      )
                    })}

                </ul>
              ) : (
                ''
              )}
            </div>

          </React.Fragment> : ''}

        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>{FIL_DIS} <i class="fa fa-info-circle" data-tip data-for="registerTip"></i></p>
          </div>
          <div className="App">
            <ReactTooltip id="registerTip" place="bottom" effect="solid" className='react_tooltip_location'>
              <p style={{ textAlign: "left" }}>Default location is MG road Bangalore.<br /> Please choose your own for sharper results.</p>
            </ReactTooltip></div>
          <div
            className={'arrow-head fa ' + this.state.dis_arrow}
            onClick={this.handle_Distance}
          ></div>
        </div>
        {this.state.distance_option === true ? (
          <div className='filter-a1'>
            <PlacesAutocomplete
              value={this.state.address}
              className="form-control"
              searchOptions={{
                //location: new window.google.maps.LatLng(localStorage.getItem("latitude"), localStorage.getItem("longitude")),
                //radius: 15000,
                //bounds: bangaloreBounds,
                types: ['locality','sublocality', 'postal_code', 'administrative_area_level_1','administrative_area_level_2'],
                strictbounds: true,
                componentRestrictions: {
                  country: 'in'
                }
              }}
              /*
              searchOptions={{
                location: new window.google.maps.LatLng(localStorage.getItem("latitude"), localStorage.getItem("longitude")),
                radius: 15000,
                types: ['address'],
                strictbounds: true,
                componentRestrictions: {
                  country: 'in'
                }
              }}*/

              onChange={this.handleplaceChange}
              onSelect={this.handleplaceSelect}
            >
             
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div >
                  <input
                    {...getInputProps({
                      placeholder: 'Input Location ...',
                      className: 'form-control',

                    })}
                    value={this.state.address}
                  />
                  <div className="autocomplete-dropdown-container"
                    style={{ position: "absolute", zIndex: "999" }}>
                    {loading && <div>Loading...</div>}
                    {console.log("suggessions", suggestions)}
                    {suggestions.length>0 && suggestions.map(suggestion => {
                      const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', cursor: 'pointer' };

                        console.log("secondary Text", suggestion.formattedSuggestion.secondaryText);

                      if((suggestion.formattedSuggestion.secondaryText != null) && (suggestion.formattedSuggestion.secondaryText.match(/Karnataka.*/) || suggestion.formattedSuggestion.secondaryText.match(/Tamil Nadu.*/) || suggestion.formattedSuggestion.secondaryText.match(/Tamilnadu.*/))){
                     
                      return (
                        <div
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                      }
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>


            <div className='f-nydf range-wrap' id="myRangeDistanceWrap">
              <p className="range-text"><span className="col">0</span> <span className="col text-center">To</span> <span className="col text-right">{MAXDIS_FILP}</span></p>
              <input
                id="myRange"
                type="range"
                name='disRange'
                className='slider'
                min="0" max={this.state.disMax}
                value={this.state.distance}
                onChange={this.handleDistanceChange}
                step="1" />
              <output className="bubble" style={{ 'left': 'calc(96% + -0.5px)' }}>{this.state.distance}</output>

            </div>

          </div>) : (
          ''
        )}
        <div className='f-b6fd'>
          <div className='n8ds-head'><p>Mentoring By</p></div>
          <div
            className={'arrow-head fa ' + this.state.ptype_arrow}
            onClick={this.handle_ptype}
          ></div>
        </div>

        <div className='filter-a1'>
          {this.state.ptype_option === true ? (
            <ul className='f-li-none'>
              <li value={''} >
                <input
                  type='radio'
                  onChange={this.handlePtypeCheck}
                  name='partner_type'
                  datatext="Individuals"
                  value={''}
                  defaultChecked={this.state.partner_type.length == 0 ? 'checked' : ''}
                />
                Both
              </li>
              <li value={1} >
                <input
                  type='radio'
                  onChange={this.handlePtypeCheck}
                  name='partner_type'
                  datatext="Institution"
                  value={1}
                  defaultChecked={this.state.partner_type.includes('1') ? 'checked' : ''}
                />
                Institution
              </li>
              <li value={2} >
                <input
                  type='radio'
                  onChange={this.handlePtypeCheck}
                  name='partner_type'
                  datatext="Individuals"
                  value={2}
                  defaultChecked={this.state.partner_type.includes('2') ? 'checked' : ''}
                />
                Individuals
              </li>
            </ul>
          ) : (
            ''
          )}
        </div>
        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>{FIL_FEEP}</p>
          </div>
          <div
            className={'arrow-head fa ' + this.state.fee_arrow}
            onClick={this.handle_Fees}
          ></div>
        </div>

        <div className='filter-a1' id="myRangeAnnualFeeWrap">
          {this.state.fees_option === true ? (
            <div className='f-nydf range-wrap' >
              <p className="range-text"><span className="col">0</span> <span className="col text-center">To</span> <span className="col text-right">{MAXFEE_FILP}</span></p>
              <input
                id="myRange"
                type="range"
                className='slider'
                name="fee_range"
                min="0" max={this.state.priceMax}
                value={this.state.annual_fee}
                onChange={this.handleAnnualfeeChange}
                step="1" />
              <output className="bubble" style={{ 'left': 'calc(90% + -0.5px)' }}>{this.state.annual_fee}</output>

            </div>
          ) : (
            ''
          )}
        </div>
        <div className='f-b6fd'>
          <div className='n8ds-head'>
            <p>Rating @ BeWise</p>
          </div>
          <div
            className={'arrow-head fa ' + this.state.review_arrow}
            onClick={this.handle_Review}
          ></div>
        </div>
        <div className='filter-a1 bewise-range-color' id="myRangeReviewWrap">
          {this.state.review_option === true ? (
            <div className='f-nydf range-wrap'>
              <p className="range-text"><span className="col">0</span>
                <span className="col text-center"></span> <span className="col text-right">5</span></p>
              <input
                id="myRangeReview"
                type="range"
                className='slider'
                name="review"
                min="0" max='5'
                value={this.state.review}
                onChange={this.handleRatingChange}
                step="1" />
              <output className="bubble" style={{ left: 'calc(0% + 8px)' }}>{this.state.review == 5 ? this.state.review : this.state.review + '+'}</output>
            </div>) : ''}

        </div>

        <div className='f-b6fd'>
          <div className='n8ds-head'><p>{RATING_GOOGLE}</p></div>
          <div
            className={'arrow-head fa ' + this.state.reviews_arrow}
            onClick={this.handle_Reviews}
          ></div>
        </div>
        <div className='filter-a1 bewise-range-color' id="myRangeSocialRatingWrap">
          {this.state.reviews_option === true ? (
            <div className='f-nydf range-wrap'>
              <p className="range-text"><span className="col">0</span>
                <span className="col text-center"></span> <span className="col text-right">5</span></p>
              <input
                id="myRange"
                type="range"
                className='slider'
                name="review_social"
                min="0" max='5'
                value={this.state.review_social}
                onChange={this.onStarClickSocial}
                step="1" />
              <output className="bubble" style={{ left: 'calc(4% + 4.25px)' }}>{this.state.review_social == 5 ? this.state.review_social : this.state.review_social + '+'}</output>
            </div>) : ''}
        </div>

        <div className='f-b6fd'>
          <div className='n8ds-head'><p>Learning Location</p></div>
          <div
            className={'arrow-head fa ' + this.state.learn_arrow}
            onClick={this.handle_learning}
          ></div>
        </div>
        <div className='filter-a1'>
          {this.state.learning_option === true ? (
            <ul className='f-li-none'>
              {this.state.schooltypeList.length > 0 &&
                this.state.schooltypeList.map((item, i) => {
                  let check = this.state.selectedLType.includes(item.id.toString()) ? 'checked' : '';
                  if (item.name != 'NA')
                    return (
                      <li value={item.id} >
                        <input
                          type='checkbox'
                          onChange={this.handleLearningCheckbox}
                          name='affilation'
                          value={item.id}
                          datatext={item.name}
                          defaultChecked={check}
                        />
                        {item.name}
                      </li>
                    )
                })}
            </ul>) : ''}
        </div>


        {type == 1 ? (
          <div className='filter-a1 text-center'>
            <hr />
            <button class="btn btn-theme btn-sm" style={{
              background: 'rgb(245 209 112)',
              color: '#fff'
            }} onClick={this.handle_clearFilter}>Apply</button>
          </div>
        ) :
          (
            <div className='filter-a1 text-center'>
              <hr />
              <button class="btn btn-theme btn-sm" style={{
                background: 'rgb(245 209 112)',
                color: '#fff'
              }} onClick={this.handle_clearFilter}>Clear Filter</button>
            </div>
          )
        }

      </div>
    )
  }
}

export default AfterSchoolActivitiesCategories;
